import { call, put, select, fork, all } from "redux-saga/effects";
import {delay} from 'redux-saga';
import axios from "axios";
import _ from "lodash";
import {
  GET_NOTIFICATION_LOGS_PATH,
  SUBMIT_OFFER_FAIL,
  SUBMIT_OFFER_SUCCESS,
  REQUEST_ACCESS_SUCCESS,
  REQUEST_ACCESS_FAIL,
  GET_USERS_YOU_SHARED_FAIL,
  GET_USERS_YOU_HAVE_ACCESS_FAIL,
  GET_All_PATIENT_OFFERED_ACCESS_FAIL,
  GET_All_ON_BORADING_DATA_FAIL,
  GET_All_ON_BORADING_CCM_DATA_FAIL,
  GET_All_FAX_REPORT_FAIL,
  GET_ASSIGNED_CAREPROVIDERS_SUCCESS,
  GET_ASSIGNED_CAREPROVIDERS_FAIL,
  GET_USERS_LIST_FAIL,
  GET_USERS_READING_UNDER_YOUR_ORGANIZATION_FAIL,
  GET_USERS_YOU_SHARED_SUCCESS,
  GET_USERS_LIST_SUCCESS,
  GET_ALL_DEVICE_LIST,
  GET_USERS_YOU_HAVE_ACCESS_SUCCESS,
  GET_All_PATIENT_OFFERED_ACCESS_SUCCESS,
  GET_All_ON_BORADING_DATA_SUCCESS,
  GET_All_ON_BORADING_CCM_DATA_SUCCESS,
  GET_All_FAX_REPORT_DATA_SUCCESS,
  GET_CURRENT_MONTH_REPORT_SUCCESS,
  GET_CURRENT_MONTH_REPORT_FAIL,
  GET_REMINDER_PATIENT_LIST_SUCCESS,
  GET_REMINDER_PATIENT_LIST_FAIL,
  GET_REMINDER_LIST_SUCCESS,
  GET_REMINDER_LIST_FAIL,
  GET_USERS_READING_UNDER_YOUR_ORGANIZATION_SUCCESS,
  GET_MY_RULES_SUCCESS,
  GET_MY_RULES_FAIL,
  GET_CAREPROVIDER_EXPECTATIONS_SUCCESS,
  GET_CAREPROVIDER_EXPECTATIONS_FAIL,
  GET_RULES_SET_BY_OTHERS_SUCCESS,
  GET_RULES_SET_BY_OTHERS_FAIL,
  GET_MY_QUESTIONNAIRES,
  GET_MY_QUESTIONNAIRES_NAME_REPETED,
  GET_MY_QUESTIONNAIRES_CARE_PROVIDER_SUCCESS,
  GET_MY_VIOLATIONS,
  GET_USER_VIOLATIONS,
  TIMER_STARTS,
  GET_PM_RECORD,
  GET_PM_RECORD_NEW,
  GET_INBOX,
  GET_USER_READINGS,
  GET_STAFF_LIST,
  GET_SHARED_ACCOUNT_LIST,
  GET_PATIENT_LIST,
  GET_ADMIN_LIST,
  GET_CLIENT_LIST,
  GET_PROFILE,
  GET_PROFILE_PATIENT,
  GET_DEVICES,
  SAVE_POPULATION,
  REMOVE_POPULATION,
  REMOVE_POPULATION_EXCEPTION,
  SAVE_POPULATION_EXCEPTION,
  GET_PROFILE_CLIENT,
  GET_CAREPROVIDERS,
  GET_CAREPROVIDER_PATIENTS,
  GET_CAREPROVIDER_STAFF,
  GET_STAFF_CLIENT,
  GET_PROFILE2,
  GET_SUPPORTS,
  GET_NO_READINGS,
  GET_NEW_PATIENT,
  GET_CLIENTS,
  GET_CONDITIONS,
  GET_PATIENT_CONDITIONS,
  GET_PATIENT_CCM_ANSWERS,
  LOGOUT_USER,
  RESET_CCM,
  GET_DEXCOMDATA,
  GET_BODYTRACE,
  GET_DEXCOM_GLUCOSE_DATA,
  GET_CAREPROVIDERS_LIST_SUCCESS,
  GET_CAREPROVIDERS_LIST_FAIL,
  GET_AUTENTICATE_FAX_PLUS,
  GET_All_PATIENT_COUNT_SUCCESS,
  GET_EXPORT_ALL_PATIENT_REPORT,
  GET_EXPORT_ALL_ONBOARING_REPORT,
  GET_EXPORT_ALL_ONBOARING_CCM_REPORT,
  GET_EXPORT_CCM_RECODES,
  GET_PRINT_CCM_RECODES,
  GET_REMOVE_PATIENT_PATH,
  GET_REMOVE_CCM_PATH,
  GET_PATIEN_EXPECTATION_CARE_PLAN,
  GET_COUNT_ON_BORADING_DATA_SUCCESS,
  GET_COUNT_ON_BORADING_CCM_DATA_SUCCESS,
  GET_ALL_DEVICE_LIST_FOR_ON_BOARDING,
  GET_EXPORT_READING_RECODES,
  GET_REMOVE_READING_PATH,
  SUBMIT_INBOX,
  READ_INBOX_SUCCESS,
  READ_ALL_INBOX_SUCCESS,
  GET_CAREPROVIDER_LIST,
  GET_UNREAD_INBOX_COUNT,
  DELETE_INBOX_SUCCESS,
  DELETE_ALL_INBOX_SUCCESS,
  GET_THIRTY_DAY_SUMMARY,
  GET_PATIENT_SUBMISSION_DETAILS,
  GET_CREATE_PATIENT_PERMISSION,
  GET_PATIENT_FREQUENCY,
  SUBMIT_TESTING_FREQUENCY,
  SAVE_PROFILE,
  SAVE_PROFILE_IMAGE,
  SUBMIT_CCM_FORM_INFORMATION,
  GET_CCM_SUBMISSION,
  GET_PATIENT_SUBMISSION_DETAILS_ERROR,
  GET_NOTIFICATION_LOGS_SUCCESS,
  GET_NOTIFICATION_LOGS_FAIL,
  GET_NOTIFICATION_LOGS_EXPORT_CSV_SUCCESS,
  GET_NOTIFICATION_LOGS_EXPORT_CSV_FAIL,
  GET_ACTIVITY_LOGS_EXPORT_CSV_SUCCESS,
  GET_ACTIVITY_LOGS_EXPORT_CSV_FAIL,
  DO_GET_ACTIVITY_LOGS_EXPORT_CSV,
  GET_ACTIVITY_LOGS_SUCCESS,
  GET_ACTIVITY_LOGS_FAIL,
  DO_GET_ACTIVITY_LOGS,
  GET_DEFAULT_PROFILE_CONFIGRATION,
  SUBMIT_PROFILE_CONFIGRATION,
  SUBMIT_PROFILE_CONFIGRATION_NOTIFY,
  GET_EXPORT_PATIENT_POPULATE_REPORT,
  GET_REMOVE_POPULATION_FILE_PATH,
  GET_GLOBAL_THRESHOLD_CARE_PROVIDER,
  DO_GET_USER_PMSESSION_TIME,
  GET_USER_PMSESSION_TIME,
  UPDATE_SIGNATURE,
  GET_All_CHAT_MESSAGES_SUCCESS,
  GET_ALL_CHAT_MESSAGE_FAIL,
  ADD_CHAT_MESSAGE,
  ONGOING_PATIENT_LIST_REQUEST_EXPORT,
  GET_VERSION_REPORTS_SUCCESS,
  GET_VERSION_REPORTS_EXPORT_SUCCESS,
  GET_VERSION_REPORTS_LOGS_PATH,
  GET_APP_VERSION_REPORTS,
  SENT_APP_UPDATE_NOTIFICATION,
  GET_ADDITIONAL_CAREPROVIDER_LIST,
  SAVE_MAINCAREPROVIDER,
  GET_ALL_STAFF_PATIENT_LIST,
  GET_ALL_STAFF_PATIENT_LIST_FAIL,
  ASSIGN_USER_SUCCESS,
  DELETE_ALL_STAFF_PATIENTS,
  REMOVE_ALL_ASSIGNED_CAREPROVIDER,
  GET_EXPORT_ALL_SHARED_ACCOUNT,
  SAVE_FAMILY_SHARED_ACCOUNT,
  UPDATED_INDIVIUAL_EXPECTATION,
  GET_PROFILE_AND_ROLS,
  EXPORT_USER_VIOLATIONS_CSV_EXPORT,
  GET_USER_VIOLATIONS_RECORD_COUNT,
  ONGOING_ON_BOARDING_REQUEST_EXPORT,
  ONGOING_USER_VIOLATION_REQUEST_PRINT,
  GET_USER_VIOLATION_PRINT,
  PATIENT_REPORT_SCHEDULAR_CONFIG,
  SUBMIT_REPORT_SCHEDULAR_CONFIG,
  GET_PATIENT_VERBAL_WELCOME_NOTES,
  GET_CAREPROVIDER_ORGANIZATION,
  ONGOING_GET_CAREPROVIDER_ORGANIZATION_REQUEST,
  GET_CPT_CODE_DASHBOARD_SUCCESS,
  GET_CPT_CODE_DASHBOARD_FAIL,
  ONGOING_CPT_CODE_DASHBOARD_REQUEST,
  GET_CPT_CODE_PATIENT_LIST_SUCCESS,
  GET_CPT_CODE_PATIENT_LIST_FAIL,
  ONGOING_CPT_CODE_PATIENT_LIST_REQUEST,
  DO_GET_COMPONENT_PATIENTS,
  GET_COMPONENT_PATIENTS_SUCCESS,
  GET_COMPONENT_PATIENTS_FAIL,
  ONGOING_COMPONENT_PATIENTS_REQUEST,
  GET_MONTHLY_PERFORMANCE_REPORT_SUCCESS,
  GET_MONTHLY_PERFORMANCE_REPORT_FAIL,
  ONGOING_MONTHLY_PERFORMANCE_REPORT_REQUEST,
  GET_MONTHLY_PHONE_CONSULTATION_DASHBOARD_SUCCESS,
  GET_MONTHLY_PHONE_CONSULTATION_DASHBOARD_FAIL,
  ONGOING_MONTHLY_PHONE_CONSULTATION_DASHBOARD_REQUEST,
  GET_MONTHLY_PHONE_TEAM_MEMBER_DETAIL_SUCCESS,
  GET_MONTHLY_PHONE_TEAM_MEMBER_DETAIL_FAIL,
  ONGOING_MONTHLY_PHONE_TEAM_MEMBER_DETAIL_REQUEST,
  GET_NON_ADHERENT_BACK_TO_BACK_REPORT_SUCCESS,
  GET_NON_ADHERENT_BACK_TO_BACK_REPORT_FAIL,
  ONGOING_NON_ADHERENT_BACK_TO_BACK_REPORT_REQUEST,
  GET_CARE_PLAN_REVIEW_REPORT_SUCCESS,
  GET_CARE_PLAN_REVIEW_REPORT_FAIL,
  ONGOING_CARE_PLAN_REVIEW_REPORT_REQUEST,
  GET_NON_ADHERENT_BACK_TO_BACK_TIMELINE_SUCCESS,
  GET_NON_ADHERENT_BACK_TO_BACK_TIMELINE_FAIL,
  ONGOING_NON_ADHERENT_BACK_TO_BACK_TIMELINE_REQUEST,
  GET_RPM_CARE_PLAN_INFORMATION_SUCCESS,
  GET_RPM_CARE_PLAN_INFORMATION_FAIL,
  ONGOING_RPM_CARE_PLAN_REQUEST,
  GET_RPM_CARE_PLAN_DETAILS_SUCCESS,
  GET_RPM_CARE_PLAN_DETAILS_FAIL,
  ONGOING_RPM_CARE_PLAN_DETAILS_REQUEST,
  GET_RPM_PATIENT_CONDITIONS_SUCCESS,
  GET_RPM_PATIENT_CONDITIONS_FAIL,
  ONGOING_RPM_PATIENT_CONDITIONS_REQUEST,
  GET_RPM_PATIENT_EXPECTATIONS_SUCCESS,
  GET_RPM_PATIENT_EXPECTATIONS_FAIL,
  ONGOING_RPM_PATIENT_EXPECTATIONS_REQUEST,
  GET_RPM_PATIENT_ICD_CODES_SUCCESS,
  GET_RPM_PATIENT_ICD_CODES_FAIL,
  ONGOING_RPM_PATIENT_ICD_CODES_REQUEST,
  GET_RPM_MEDICAL_NECESSITY_CONFIG,
  GET_RPM_MEDICAL_NECESSITY_CONFIG_SUCCESS,
  GET_RPM_MEDICAL_NECESSITY_CONFIG_FAIL,
  ONGOING_RPM_MEDICAL_NECESSITY_CONFIG_REQUEST,
  DO_GET_RPM_STAFF_MEMBERS,
  GET_RPM_STAFF_MEMBERS_SUCCESS,
  GET_RPM_STAFF_MEMBERS_FAIL,
  ONGOING_RPM_STAFF_MEMBERS_REQUEST,
  GET_ESCALATION_PLANS,
  ONGOING_ESCALATION_PLAN_REQUEST,
  GET_GOALS_OF_CARE,
  ONGOING_GOALS_OF_CARE_REQUEST,
  GET_ESCALATION_PLANS_ADMIN,
  ONGOING_ESCALATION_PLAN_ADMIN_REQUEST,
  GET_GOALS_OF_CARE_ADMIN,
  ONGOING_GOALS_OF_CARE_ADMIN_REQUEST,
  GET_ESCALATION_PLANS_STAFF,
  ONGOING_ESCALATION_PLAN_STAFF_REQUEST,
  GET_GOALS_OF_CARE_STAFF,
  ONGOING_GOALS_OF_CARE_STAFF_REQUEST,
  DO_UPDATE_RPM_CARE_PLAN,
  DO_SAVE_RPM_CARE_PLAN,
  SAVE_RPM_CARE_PLAN_SUCCESS,
  SAVE_RPM_CARE_PLAN_FAIL,
  UPDATE_RPM_CARE_PLAN_SUCCESS,
  SAVE_OR_UPDATE_RPM_CARE_PLAN_FAIL,
  FETCH_RPM_CARE_PLAN_LIST,
  FETCH_RPM_CARE_PLAN_LIST_SUCCESS,
  FETCH_RPM_CARE_PLAN_LIST_FAIL,
  ONGOING_RPM_CARE_PLAN_LIST_REQUEST,
  GET_DASHBOARD_COUNTS,
  GET_DASHBOARD_COUNTS_SUCCESS,
  ONGOING_DASHBOARD_COUNTS_REQUEST,
} from "../actions/types";
import { toast } from "react-toastify";
import { ROLES, USERS_ROLE } from "../../constants/role.constant";
import axiosClient from "../../axios/axios";
import encryptRequest from "../../helpers/encryptationHelper";
import moment from "moment";

const staffCareproviderRoles = USERS_ROLE.filter((item) => item.type == "Staff" || item.type == "Careprovider").map((item) => item.role);

axios.defaults.baseURL = process.env.REACT_APP_HOST_URL_PREFIX;

export const getToken = (state) => state.user.userDetails.token;

export const getRole = (state) => {
  if (staffCareproviderRoles.includes(state.user.userDetails.role)) {
    return 'careprovider'
  } else {
    return state.user.userDetails.role
  }
};

export const getIsClient = (state) => state.user.userDetails.region;

export const getIsCareProvider = (state) => state.user.userDetails.isCareProvider;

export function* updateRpmCarePlan(action) {
  yield put({
    type: ONGOING_RPM_CARE_PLAN_REQUEST,
    payload: true
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if(role === 'admin' || role === 'support'){
    path = '/admin';
  }else if(isClient){
    path = '/client';
  }else if(role == 'careprovider'){
    path = '/careprovider';
  }else{
    path = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: `${path}/rpm-care-plan-details`,
    successType: UPDATE_RPM_CARE_PLAN_SUCCESS,
    errorType: SAVE_OR_UPDATE_RPM_CARE_PLAN_FAIL
  };
  yield call(reusableSimplePutRequest, custom_param);
  
  // Fetch RPM care plan list after successful update
  yield put({
    type: "DO_FETCH_RPM_CARE_PLAN_LIST",
    payload: { patientId: action.payload.formData.patientId }
  });
  // Refresh the full RPM care plan information so UI gets computed names
  if (action.payload && action.payload.formData && action.payload.formData.patientId) {
    yield put({ type: "DO_GET_RPM_CARE_PLAN_INFORMATION", payload: { patientId: action.payload.formData.patientId } });
  }
}

// New saga function for saving RPM Care Plan
export function* saveRpmCarePlan(action) {
  yield put({
    type: ONGOING_RPM_CARE_PLAN_REQUEST,
    payload: true
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if(role === 'admin' || role === 'support'){
    path = '/admin';
  }else if(isClient){
    path = '/client';
  }else if(role == 'careprovider'){
    path = '/careprovider';
  }else{
    path = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: path + "/rpm-care-plan",
    successType: SAVE_RPM_CARE_PLAN_SUCCESS,
    errorType: SAVE_RPM_CARE_PLAN_FAIL
  };
  yield call(reusableSimplePostRequest, custom_param);
  
  // Fetch RPM care plan list after successful save
  yield put({
    type: "DO_FETCH_RPM_CARE_PLAN_LIST",
    payload: { patientId: action.payload.patientId }
  });
  // Refresh the full RPM care plan information so UI gets computed names
  if (action.payload && action.payload.patientId) {
    yield put({ type: "DO_GET_RPM_CARE_PLAN_INFORMATION", payload: { patientId: action.payload.patientId } });
  }
}

// New saga for getting RPM patient conditions
export function* getRpmPatientConditions(action) {
  yield put({
    type: ONGOING_RPM_PATIENT_CONDITIONS_REQUEST,
    payload: true
  });
  try {
    let role = yield select(getRole);
    let isClient = yield select(getIsClient);
    let path;
    if(role === 'admin' || role === 'support'){
      path = '/admin';
    }else if(isClient){
      path = '/client';
    }else if(role == 'careprovider'){
      path = '/careprovider';
    }else{
      path = '/patient';
    }
    
    const patientId = action.payload.patientId;
    let token = yield select(getToken);
    
    const response = yield axiosClient.get(
      `${path}/patient-conditions?patientId=${patientId}`,
      { headers: { "x-auth-token": token } }
    );
    
    if (response.data && response.data.success) {
      yield put({
        type: GET_RPM_PATIENT_CONDITIONS_SUCCESS,
        payload: response.data?.data || {}
      });
    } else {
      yield put({
        type: GET_RPM_PATIENT_CONDITIONS_FAIL,
        payload: null
      });
    }
  } catch (error) {
    yield put({
      type: GET_RPM_PATIENT_CONDITIONS_FAIL,
      payload: null
    });
  } finally {
    yield put({
      type: ONGOING_RPM_PATIENT_CONDITIONS_REQUEST,
      payload: false
    });
  }
}

// New saga for getting the ICD-10 code master list (used by the category -> code cascading dropdown)
export function* getRpmPatientIcdCodes(action) {
  yield put({
    type: ONGOING_RPM_PATIENT_ICD_CODES_REQUEST,
    payload: true
  });
  try {
    let role = yield select(getRole);
    let isClient = yield select(getIsClient);
    let path;
    if(role === 'admin' || role === 'support'){
      path = '/admin';
    }else if(isClient){
      path = '/client';
    }else if(role == 'careprovider'){
      path = '/careprovider';
    }else{
      path = '/patient';
    }

    let token = yield select(getToken);

    const response = yield axiosClient.get(
      `${path}/icd-codes`,
      { headers: { "x-auth-token": token } }
    );

    if (response.data && response.data.success) {
      yield put({
        type: GET_RPM_PATIENT_ICD_CODES_SUCCESS,
        payload: response.data?.data || []
      });
    } else {
      yield put({
        type: GET_RPM_PATIENT_ICD_CODES_FAIL,
        payload: null
      });
    }
  } catch (error) {
    yield put({
      type: GET_RPM_PATIENT_ICD_CODES_FAIL,
      payload: null
    });
  } finally {
    yield put({
      type: ONGOING_RPM_PATIENT_ICD_CODES_REQUEST,
      payload: false
    });
  }
}

// New saga for getting RPM patient expectations by condition
export function* getRpmPatientExpectations(action) {
  yield put({
    type: ONGOING_RPM_PATIENT_EXPECTATIONS_REQUEST,
    payload: true
  });
  try {
    let role = yield select(getRole);
    let isClient = yield select(getIsClient);
    let path;
    if(role === 'admin' || role === 'support'){
      path = '/admin';
    }else if(isClient){
      path = '/client';
    }else if(role == 'careprovider'){
      path = '/careprovider';
    }else{
      path = '/patient';
    }
    
    const { conditionIds, patientId } = action.payload;
    let token = yield select(getToken);

        
    const response = yield axiosClient.get(
      `${path}/patient-expectations-by-condition?patientId=${patientId}&conditionIds=${conditionIds}`,
      { headers: { "x-auth-token": token } }
    );
    
    console.log('[DEBUG] getRpmPatientExpectations - API Response:', response.data);
    
    if (response.data && response.data.success) {
      console.log('[DEBUG] Expectations data being stored in Redux:', response.data.data);
      yield put({
        type: GET_RPM_PATIENT_EXPECTATIONS_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({
        type: GET_RPM_PATIENT_EXPECTATIONS_FAIL,
        payload: null
      });
    }
  } catch (error) {
    yield put({
      type: GET_RPM_PATIENT_EXPECTATIONS_FAIL,
      payload: null
    });
  } finally {
    yield put({
      type: ONGOING_RPM_PATIENT_EXPECTATIONS_REQUEST,
      payload: false
    });
  }
}

export function* getRpmMedicalNecessityConfig(action) {
  yield put({
    type: ONGOING_RPM_MEDICAL_NECESSITY_CONFIG_REQUEST,
    payload: true
  });
  try {
    let role = yield select(getRole);
    let isClient = yield select(getIsClient);
    let path;
    if(role === 'admin' || role === 'support'){
      path = '/admin';
    }else if(isClient){
      path = '/client';
    }else if(role == 'careprovider'){
      path = '/careprovider';
    }else{
      path = '/patient';
    }
    
    const { conditionIds, patientId } = action.payload;
    let token = yield select(getToken);
    console.log('[DEBUG] Fetching config for conditionIds:' + conditionIds);
    const response = yield axiosClient.get(
      `${path}/rpm-medical-necessity-config?conditionIds=${conditionIds}${patientId ? `&patientId=${patientId}` : ''}`,
      { headers: { "x-auth-token": token } }
    );
    
    if (response.data && response.data.success) {
      yield put({
        type: GET_RPM_MEDICAL_NECESSITY_CONFIG_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({
        type: GET_RPM_MEDICAL_NECESSITY_CONFIG_FAIL,
        payload: null
      });
    }
  } catch (error) {
    yield put({
      type: GET_RPM_MEDICAL_NECESSITY_CONFIG_FAIL,
      payload: null
    });
  } finally {
    yield put({
      type: ONGOING_RPM_MEDICAL_NECESSITY_CONFIG_REQUEST,
      payload: false
    });
  }
}

export function* getRpmStaffMembers(action) {
  yield put({
    type: ONGOING_RPM_STAFF_MEMBERS_REQUEST,
    payload: true
  });
  try {
    let role = yield select(getRole);
    let isClient = yield select(getIsClient);
    let path;
    if (role === 'admin' || role === 'support') {
      path = '/admin';
    } else if (isClient) {
      path = '/client';
    } else if (role == 'careprovider') {
      path = '/careprovider';
    } else {
      path = '/patient';
    }

    const patientId = action && action.payload && action.payload.patientId;
    let token = yield select(getToken);

    const url = patientId
      ? `${path}/rpm-staff-members?patientId=${patientId}`
      : `${path}/rpm-staff-members`;

    const response = yield axiosClient.get(url, {
      headers: { "x-auth-token": token }
    });

    if (response.data && response.data.success) {
      const apiData = response.data.data || {};
      yield put({
        type: GET_RPM_STAFF_MEMBERS_SUCCESS,
        payload: {
          availableStaff: apiData.availableStaff || apiData.staff || [],
          assignedStaff: apiData.assignedStaff || []
        }
      });
    } else {
      yield put({
        type: GET_RPM_STAFF_MEMBERS_FAIL,
        payload: null
      });
    }
  } catch (error) {
    console.error('Error fetching RPM staff members:', error);
    yield put({
      type: GET_RPM_STAFF_MEMBERS_FAIL,
      payload: null
    });
  } finally {
    yield put({
      type: ONGOING_RPM_STAFF_MEMBERS_REQUEST,
      payload: false
    });
  }
}


export function* genericError(action) {
  yield put({
    type: SUBMIT_OFFER_SUCCESS,
    payload: { isGenericSuccess: false }
  });
}

export function* updatePatientListPath(action) {
  yield put({
    type: GET_REMOVE_PATIENT_PATH,
    payload: undefined
  });
  yield put({
    type: GET_REMOVE_CCM_PATH,
    payload: undefined
  });
  yield put({
    type: GET_REMOVE_READING_PATH,
    payload: undefined
  });
  yield put({
    type: GET_REMOVE_POPULATION_FILE_PATH,
    payload: undefined
  });
  yield put({
    type: GET_VERSION_REPORTS_LOGS_PATH,
    payload: undefined
  });
}

export  function* updateNotificationLogsFilePath(action) {
  yield put({
    type: GET_NOTIFICATION_LOGS_PATH,
    payload: undefined
  });
  yield put({
    type: GET_VERSION_REPORTS_LOGS_PATH,
    payload: undefined
  });
}

export  function* addChatMessages(message) {
  yield put({
    type: ADD_CHAT_MESSAGE,
    payload: message.payload
  });
}

export function* submitOfferSaga(action) {
  //   yield put({ type: LOADING_BUTTON_START });
  try {
    const payloadData = action.payload;
    let token = yield select(getToken);
    let url = "/patient/sharing/offer-readings";
    
    const response = yield axiosClient.post(url, payloadData, {
      headers: {
        "x-auth-token": token
      }
    });
    const responseData = response.data;
    
    // yield put({ type: LOADING_BUTTON_STOP });
    yield put({
      type: SUBMIT_OFFER_SUCCESS,
      payload: { isGenericSuccess: true }
    });
    yield all([
      call(usersGivenAccessMyReading),
      call(usersOfferedAccess),
      call(assignedUsersList),
      call(usersOfferedAccessOrganization)
    ]);
  } catch (error) {
    
    yield put({
      type: SUBMIT_OFFER_FAIL,
      payload: error.response.data
    });
    // yield put({ type: LOADING_BUTTON_STOP });
  }
}
export function* requestAccess(action) {
  
  //   yield put({ type: LOADING_BUTTON_START });
  try {
    const payloadData = action.payload;
    let token = yield select(getToken);
    let url = "/patient/sharing/request-access-readings";
    
    const response = yield axiosClient.post(url, payloadData, {
      headers: {
        "x-auth-token": token
      }
    });
    const responseData = response.data;
    
    // yield put({ type: LOADING_BUTTON_STOP });
    yield put({
      type: REQUEST_ACCESS_SUCCESS,
      payload: { isGenericSuccess: true }
    });
    yield all([
      call(usersGivenAccessMyReading),
      call(usersOfferedAccess),
      call(assignedUsersList),
      call(usersOfferedAccessOrganization)
    ]);
  } catch (error) {
    
    yield put({
      type: REQUEST_ACCESS_FAIL,
      payload: error.response.data
    });
    // yield put({ type: LOADING_BUTTON_STOP });
  }
}
export function* usersGivenAccessMyReading(action) {
  const custom_param = {
    endpoint: "/patient/sharing/given-access",
    successType: GET_USERS_YOU_SHARED_SUCCESS,
    errorType: GET_USERS_YOU_SHARED_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getAllDevicesList(action) {
  const custom_param = {
    endpoint: "/__public__/data?type=devices",
    successType: GET_ALL_DEVICE_LIST,
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
// 
export function* getNotificationLogs(action) {
  yield put({
    type: "ONGOING_NOTIFICATION_LOGS_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let endpoint;
  if (role == 'admin' || role === "support") {
   endpoint = 
   "/admin/notification-logs" 
  } if (role == 'careprovider') {
    endpoint = 
    "/careprovider/notification-logs" 
   } if (isClient) {
    endpoint = 
    "/client/notification-logs" 
   }if (role == 'patient') {
    endpoint = 
    "/patient/notification-logs" 
   }
  let url = endpoint + jsonToQueryString(action.payload);
  const custom_param = {
    action: action,
    endpoint: url,
    successType: GET_NOTIFICATION_LOGS_SUCCESS,
    errorType: GET_NOTIFICATION_LOGS_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
} 
export function* getNotificationLogsExportCSV(action) {
  yield put({
    type: "ONGOING_NOTIFICATION_MESSAGES_LIST_EXPORT_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let endpoint;
  if (role == 'admin' || role === "support") {
   endpoint = 
   "/admin/notification-logs-data-export" 
  } if (role == 'careprovider') {
    endpoint = 
    "/careprovider/notification-logs-data-export" 
   } if (isClient) {
    endpoint = 
    "/client/notification-logs-data-export" 
   }if (role == 'patient') {
    endpoint = 
    "/patient/notification-logs-data-export" 
   }
   let url = endpoint + jsonToQueryString(action.payload);
   const custom_param = {
    action: action,
    endpoint: url,
    successType: GET_NOTIFICATION_LOGS_EXPORT_CSV_SUCCESS,
    errorType: GET_NOTIFICATION_LOGS_EXPORT_CSV_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
} 

export function* getActivityLogsExportCSV(action) {
  yield put({
    type: "ONGOING_REQUEST",
    payload: true
  });
  
  try {
    let role = yield select(getRole);
    let isClient = yield select(getIsClient);
    let token = yield select(getToken);
    let endpoint;
    
    if (role == 'admin' || role === "support") {
     endpoint = "/admin/activity-logs-data-export" 
    } if (role == 'careprovider') {
      endpoint = "/careprovider/activity-logs-data-export" 
     } if (isClient) {
      endpoint = "/client/activity-logs-data-export" 
     } if (role == 'patient') {
      endpoint = "/patient/activity-logs-data-export" 
     }
     
    let url = endpoint + jsonToQueryString(action.payload);
    
    const response = yield axiosClient.get(url, {
      headers: {
        Accept: "text/csv,application/octet-stream",
        "Content-Type": "application/json",
        "x-auth-token": token,
      },
      responseType: 'blob'
    });
    
    if (response.data.type.includes("application/json")) {
      const errorText = yield response.data.text();
      const errorJson = JSON.parse(errorText);
      yield put({
        type: GET_ACTIVITY_LOGS_EXPORT_CSV_FAIL,
        payload: errorJson.message || "Failed to download file"
      });
    } else {
      // Handle CSV file download
      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `activity-logs-${moment().format("YYYYMMDD-HHmmss")}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      
      yield put({
        type: GET_ACTIVITY_LOGS_EXPORT_CSV_SUCCESS,
        payload: "File downloaded successfully"
      });
    }
  } catch (error) {
    yield put({
      type: GET_ACTIVITY_LOGS_EXPORT_CSV_FAIL,
      payload: "Failed to download file"
    });
  } finally {
    yield put({
      type: "ONGOING_REQUEST",
      payload: false
    });
  }
}

export function* getActivityLogs(action) {
  yield put({
    type: "ONGOING_REQUEST",
    payload: true
  });
  
  try {
    let role = yield select(getRole);
    let isClient = yield select(getIsClient);
    let endpoint;
    
    if (role == 'admin' || role === "support") {
     endpoint = "/admin/activity-logs" 
    } if (role == 'careprovider') {
      endpoint = "/careprovider/activity-logs" 
     } if (isClient) {
      endpoint = "/client/activity-logs" 
     } if (role == 'patient') {
      endpoint = "/patient/activity-logs" 
     }
     
    let url = endpoint + jsonToQueryString(action.payload);
    
    const custom_param = {
      action: action,
      endpoint: url,
      successType: GET_ACTIVITY_LOGS_SUCCESS,
      errorType: GET_ACTIVITY_LOGS_FAIL
    };
    yield call(reusableSimpleGetRequest, custom_param);
  } catch (error) {
    yield put({
      type: GET_ACTIVITY_LOGS_FAIL,
      payload: "Failed to fetch activity logs"
    });
    yield put({
      type: "ONGOING_REQUEST",
      payload: false
    });
  }
}
 
export function* checkCreatePatientPermission(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if(role === 'admin' || role === 'support'){
    path = '/admin';
  }else if(isClient){
    path = '/client';
  }else if(role == 'careprovider'){
    path = '/careprovider';
  }else{
    path = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: path + "/create-patient-permission",
    successType: GET_CREATE_PATIENT_PERMISSION,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getDeviceListForOnBoarding(action) {  
  yield put({
      type: "ONGOING_REQUEST_DEVICE",
      payload: true
    });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let path;
  delete action.payload.patientPath;
  delete action.payload.isClient;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  } else {
    path = "/patient/";
  }
  const custom_param = {
    action: action,
    endpoint: path + "get-device-for-on-borading" + jsonToQueryString(action.payload),
    successType: GET_ALL_DEVICE_LIST_FOR_ON_BOARDING,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* usersOfferedAccess(action) {
  let endpoint;
  let role = yield select(getRole);
  if (action.payload && action.payload.client) {
    if (role === "support" || role === "admin") {
      endpoint = "/admin/users";
    } else {
      endpoint = "/client/users";
    }
  } else {
    endpoint = "/patient/sharing/can-access";
  }
  const custom_param = {
    endpoint: endpoint,
    successType: GET_USERS_YOU_HAVE_ACCESS_SUCCESS,
    errorType: GET_USERS_YOU_HAVE_ACCESS_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}

export function* allPatientOfferedAccess(action){
  yield put({
    type: GET_All_PATIENT_OFFERED_ACCESS_SUCCESS,
    payload: undefined
  });
  yield put({
    type: "ONGOING_PATIENT_LIST_REQUEST",
    payload: true
  });
  yield put({
    type: GET_REMOVE_PATIENT_PATH,
    payload: undefined
  });
  let endpoint;
  let role = yield select(getRole);
  if (action.payload && action.payload) {
    if (role === "support" || role === "admin") {
      endpoint = "/admin/allPatients";
    } else if (role == "patient"){
      endpoint = "/patient/allPatients";
    } else if(role == "careprovider") {
      endpoint = "/careprovider/allPatients";
    } else {
      endpoint = "/client/allPatients";
    }
  }
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_All_PATIENT_OFFERED_ACCESS_SUCCESS,
    errorType: GET_All_PATIENT_OFFERED_ACCESS_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* allPatientCount(action){
  yield put({
    type: GET_All_PATIENT_COUNT_SUCCESS,
    payload: undefined
  });
  yield put({
    type: GET_REMOVE_PATIENT_PATH,
    payload: action.payload
  });
  let endpoint;
  let role = yield select(getRole);
  if (role === "support" || role === "admin") {
    endpoint = "/admin/getPatientRecodes";
  } 
  else if(role === "careprovider" ){
    endpoint = "/careprovider/getPatientRecodes";
  } 
  else {
    endpoint = "/client/getPatientRecodes";
  }
  const custom_param = {
    endpoint: action.payload ? endpoint + jsonToQueryString(action.payload) : endpoint,
    successType: GET_All_PATIENT_COUNT_SUCCESS
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* exportAdminPatientList(action){
  yield put({
    type:  ONGOING_PATIENT_LIST_REQUEST_EXPORT,
    payload: true
  });
  let endpoint;
  let role = yield select(getRole);
  if (role === "support" || role === "admin") {
    endpoint = "/admin/export-patient";
  }else if(role == "careprovider"){
    endpoint = "/careprovider/export-patient";
  }else{
    endpoint = "/client/export-patient";
  }
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_EXPORT_ALL_PATIENT_REPORT
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* exportOnboardingList(action){
  let endpoint;
  yield put({
    type:  ONGOING_ON_BOARDING_REQUEST_EXPORT,
    payload: true
  });
  let role = yield select(getRole);
  if (role === "support" || role === "admin") {
    endpoint = "/admin/on-boarding-data-export";
  }else if(role == "careprovider"){
    endpoint = "/careprovider/on-boarding-data-export";
  }
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_EXPORT_ALL_ONBOARING_REPORT
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* exportOnboardingCCM(action){
  let endpoint;
  let role = yield select(getRole);
  if (role === "support" || role === "admin") {
    endpoint = "/admin/on-boarding-ccm-data-export";
  }else if(role == "careprovider"){
    endpoint = "/careprovider/on-boarding-ccm-data-export";
  }
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_EXPORT_ALL_ONBOARING_CCM_REPORT
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* exportCCMRecodes(action){
  let endpoint;
  let role = yield select(getRole);  
  yield put({
    type: "ONGOING_PM_SESSION__EXPORT_REQUEST",
    payload: true
  });
  if (role === "support" || role === "admin") {
    endpoint = "/admin/monitoring/exportPMSession";
  } else{
    endpoint = "/careprovider/monitoring/exportPMSession";
  }
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_EXPORT_CCM_RECODES
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* printCCMRecodes(action){
  let endpoint;
  let role = yield select(getRole); 
  yield put({
    type: "ONGOING_PM_SESSION_PRINT_REQUEST",
    payload: true
  });
  if (role === "support" || role === "admin") {
    endpoint = "/admin/monitoring/printCCMTracking";
  } else{
    endpoint = "/careprovider/monitoring/printCCMTracking";
  }
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_PRINT_CCM_RECODES
  };
  yield call(reusableSimpleGetRequest, custom_param);
}

export function* allOnBoarding(action){
  yield put({
    type: GET_REMOVE_PATIENT_PATH,
    payload: undefined
  });
  yield put({
    type: "ONGOING_BOARDING_REQUEST",
    payload: true
  });
  let endpoint;
  let role = yield select(getRole);
  if (action.payload && action.payload) {
    if (role === "support" || role === "admin") {
      endpoint = "/admin/on-boarding-data";
    } else {
      endpoint = "/careprovider/on-boarding-data";
    }
  } else {
    endpoint = "/careprovider/on-boarding-data";
  }
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_All_ON_BORADING_DATA_SUCCESS,
    errorType: GET_All_ON_BORADING_DATA_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* allOnBoardingCCM(action){
  yield put({
    type: GET_REMOVE_PATIENT_PATH,
    payload: undefined
  });
  let endpoint;
  let role = yield select(getRole);
  if (action.payload && action.payload) {
    if (role === "support" || role === "admin") {
      endpoint = "/admin/on-boarding-ccm-data";
    } else {
      endpoint = "/careprovider/on-boarding-ccm-data";
    }
  } else {
    endpoint = "/careprovider/on-boarding-ccm-data";
  }
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_All_ON_BORADING_CCM_DATA_SUCCESS,
    errorType: GET_All_ON_BORADING_CCM_DATA_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* allFaxReports(action){
  yield put({
    type: GET_REMOVE_PATIENT_PATH,
    payload: undefined
  });
  let endpoint;
  let role = yield select(getRole);
  if (action.payload && action.payload) {
    if (role === "support" || role === "admin") {
      endpoint = "/admin/get-fax-reports";
    } else {
      endpoint = "/careprovider/get-fax-reports";
    }
  } else {
    endpoint = "/careprovider/get-fax-reports";
  }
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_All_FAX_REPORT_DATA_SUCCESS,
    errorType: GET_All_FAX_REPORT_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getAllChatMessages(action){
  yield put({
    type: "ONGOING_CHAT_MESSAGE_LOAD_REQUEST",
    payload: true
  });
  let endpoint;
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  if (action.payload && action.payload) {
    if (role === "support" || role === "admin") {
      endpoint = "/admin/chat-messages";
    } else if (isClient) {
      endpoint = "/client/chat-messages";
    } else if (isCareProvider) {
      endpoint = "/careprovider/chat-messages";
    } else {
      endpoint = "/patient/chat-messages";
    }
  } else {
    endpoint = "/careprovider/chat-messages";
  }  
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_All_CHAT_MESSAGES_SUCCESS,
    errorType: GET_ALL_CHAT_MESSAGE_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* onBoardingDataCount(action){
  let endpoint;
  let role = yield select(getRole);
  if (role === "support" || role === "admin") {
    endpoint = "/admin/on-boarding-count";
  } else {
    endpoint = "/careprovider/on-boarding-count";
  }
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_COUNT_ON_BORADING_DATA_SUCCESS,
  };
  yield call(reusableSimpleGetRequest, custom_param);
}

export function* onBoardingCCMDataCount(action){
  let endpoint;
  let role = yield select(getRole);
  if (role === "support" || role === "admin") {
    endpoint = "/admin/on-boarding-ccm-count";
  } else {
    endpoint = "/careprovider/on-boarding-ccm-count";
  }
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_COUNT_ON_BORADING_CCM_DATA_SUCCESS,
  };
  yield call(reusableSimpleGetRequest, custom_param);
}

export function* assignedUsersList(action) {

  let endpoint;
  let role = yield select(getRole);
  if (role === "support" || role === "admin") {
    endpoint = "/admin/assigned-users-list/" + encryptRequest(action.payload.careproviderId);
  } else {
    endpoint = "/patient/assigned-users-list";
  }
  const custom_param = {
    endpoint: endpoint,
    successType: GET_USERS_LIST_SUCCESS,
    errorType: GET_USERS_LIST_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getAssignedUsersListNew(action) {
  let endpoint;
  yield put({
    type: "ONGOING_REQUEST_ASSIGNED_USERS_LIST",
    payload: true
  });
  let role = yield select(getRole);
  if (role === "support" || role === "admin") {
    endpoint = "/admin/assigned-users-list/" + encryptRequest(action.payload.careproviderId);
  } else {
    endpoint = "/patient/assigned-users-list-new";
  }
  const custom_param = {
    endpoint: endpoint,
    successType: GET_USERS_LIST_SUCCESS,
    errorType: GET_USERS_LIST_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* currentMonthReport(action) {
  let endpoint;
  yield put({
    type: "ONGOING_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let isCareProvider = yield select(getIsCareProvider);

  if (role != "admin") {
    endpoint = "/careprovider/month-report"
  } else {
    endpoint = "/admin/month-report"
  }

  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_CURRENT_MONTH_REPORT_SUCCESS,
    errorType: GET_CURRENT_MONTH_REPORT_FAIL
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* getReminderPatientList(action) {
  let endpoint;
  let role = yield select(getRole);
  if(role === 'admin'){
    endpoint =
    "/admin/reminder-patient-list" 
    + jsonToQueryString(action.payload);
  const custom_param = {
    endpoint: endpoint,
    successType: GET_REMINDER_PATIENT_LIST_SUCCESS,
    errorType: GET_REMINDER_PATIENT_LIST_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
  }
}
export function* getReminderList(action) {
  let endpoint;
  let role = yield select(getRole);
  endpoint =
    "/admin/reminder-select-patient-list" +
    "/" +
    action.payload.selectedMonth +
    "/" +
    action.payload.selectedYear +
    "/" +
    action.payload.patient;
  const custom_param = {
    endpoint: endpoint,
    successType: GET_REMINDER_LIST_SUCCESS,
    errorType: GET_REMINDER_LIST_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* usersOfferedAccessOrganization(action) {
  // const custom_param = {
  //   endpoint: "/patient/sharing/organization-access",
  //   successType: GET_USERS_READING_UNDER_YOUR_ORGANIZATION_SUCCESS,
  //   errorType: GET_USERS_READING_UNDER_YOUR_ORGANIZATION_FAIL
  // };
  // yield call(reusableSimpleGetRequest, custom_param);
}
export function* getAssignedCareProviders(action) {
  const custom_param = {
    endpoint: "/careprovider/assigned-careproviders",
    successType: GET_ASSIGNED_CAREPROVIDERS_SUCCESS,
    errorType: GET_ASSIGNED_CAREPROVIDERS_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* deletePermission(action) {
  const custom_param = {
    action: action,
    endpoint: "/patient/sharing/permission" + "/" + encryptRequest(action.payload.id),
    successType: GET_USERS_READING_UNDER_YOUR_ORGANIZATION_SUCCESS,
    errorType: GET_USERS_READING_UNDER_YOUR_ORGANIZATION_FAIL,
    deletePermission: true
  };
  yield call(reusableSimpleDeleteRequest, custom_param);
}

export function* approvePermission(action) {
  const custom_param = {
    action: action,
    endpoint: "/patient/sharing/permission" + "/" + encryptRequest(action.payload.id),
    successType: GET_USERS_READING_UNDER_YOUR_ORGANIZATION_SUCCESS,
    errorType: GET_USERS_READING_UNDER_YOUR_ORGANIZATION_FAIL,
    deletePermission: true
  };
  yield call(reusableSimplePutRequest, custom_param);
}
export function* getMyRules(action) {
  let endpoint;
  if (action && action.payload && action.payload.isClient) {
    endpoint = "/client/careprovider/" + encryptRequest(action.payload.user) + "/rules";
  } else {
    endpoint = "/patient/rules/created";
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_MY_RULES_SUCCESS,
    errorType: GET_MY_RULES_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getCareProviderExpectations(action) {
  let endpoint =
    "/admin/get-careprovider-expectations/" + encryptRequest(action.payload.careproviderId);
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_CAREPROVIDER_EXPECTATIONS_SUCCESS,
    errorType: GET_CAREPROVIDER_EXPECTATIONS_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getCareProviderExpectationsReports(action) {
  yield put({
    type:"ONGOING_POPULATION_DATA_REQUEST",
    payload: true,
  })
  let endpoint =
    "/admin/get-careprovider-expectations-report/" + encryptRequest(action.payload.careproviderId);
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_CAREPROVIDER_EXPECTATIONS_SUCCESS,
    errorType: GET_CAREPROVIDER_EXPECTATIONS_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getMyExpectationsReport(action) {
  yield put({
    type:"ONGOING_POPULATION_DATA_REQUEST",
    payload: true,
  })
  const custom_param = {
    action: action,
    endpoint: "/careprovider/my-expectations-report",
    successType: GET_CAREPROVIDER_EXPECTATIONS_SUCCESS,
    errorType: GET_CAREPROVIDER_EXPECTATIONS_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getRuleSetByOthers(action) {
  const custom_param = {
    action: action,
    endpoint: "/patient/rules/created-by-others",
    successType: GET_RULES_SET_BY_OTHERS_SUCCESS,
    errorType: GET_RULES_SET_BY_OTHERS_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* saveCCMFormInformation(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if(role === 'admin' || role === 'support'){
    path = '/admin';
  }else if(isClient){
    path = '/client';
  }else if(role == 'careprovider'){
    path = '/careprovider';
  }else{
    path = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: path + "/save-ccm-information",
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* sentCCMCarePlanFormReport(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if(role === 'admin' || role === 'support'){
    path = '/admin';
  }else if(isClient){
    path = '/client';
  }else if(role == 'careprovider'){
    path = '/careprovider';
  }else{
    path = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: path + "/sent-ccm-careplan-fax-report",
    successType: "GET_CURRENT_MONTH_REPORT_SUCCESS",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}

export function* savePatientExpectationRule(action){
  let endpoint = "";
  let role = yield select(getRole);
  if (role != "admin") {
    endpoint = "/careprovider/rule/createIndiviualExpectation"
  } else {
    endpoint = "/admin/rule/createIndiviualExpectation"
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: "UPDATED_INDIVIUAL_EXPECTATION",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}


export function* saveVitalRule(action) {
  const custom_param = {
    action: action,
    endpoint: "/patient/rules/vital",
    successType: "",
    errorType: ""
  };
  
  if (action.payload._id) {
    custom_param.endpoint =
      "/patient/rules" +
      "/" +
      encryptRequest(action.payload._id) +
      "/" +
      encryptRequest(action.payload.ruleType);
    yield call(reusableSimplePutRequest, custom_param);
    return;
  }

  yield call(reusableSimplePostRequest, custom_param);
}

export function* saveQuestionnaire(action) {
  const custom_param = {
    action: action,
    endpoint: "/careprovider/questionnaire/createQuestionnaire",
    successType: "SUBMIT_QUESTIONNAIRE",
    errorType: ""
  };
  
  // if (action.payload._id) {
  //   custom_param.endpoint =
  //     "/patient/rules" +
  //     "/" +
  //     action.payload._id +
  //     "/" +
  //     action.payload.ruleType;
  //   yield call(reusableSimplePutRequest, custom_param);
  //   return;
  // }

  yield call(reusableSimplePostRequest, custom_param);
}

export function* savePMTime(action) {
  const custom_param = {
    action: action,
    endpoint: "/patient/monitoring/ccm-tracking",
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
/**
 * Sent Chat Text Message
 * @param {*} action passed param
 */
export function* sentChatMessage(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if (role === 'admin' || role === 'support') {
    path = '/admin';
  } else if (isClient) {
    path = '/client';
  } else if (role == 'careprovider') {
    path = '/careprovider';
  } else {
    path = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: path + "/sent-text-messages",
    successType: GET_CURRENT_MONTH_REPORT_SUCCESS,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* sendQuestionnaireMail(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let endpoint;

  let path;
  if (isClient) {
    path = "/client/";
  } else {
    path = "/careprovider/";
  }
  const custom_param = {
    action: action,
    endpoint: path+"sendQuestionnaireEmail",
    successType: "",
    errorType: ""
  };
  yield call(reusableSendSimplePostRequest, custom_param);
}
export function* updatePMTime(action) {
  let role = yield select(getRole);
  let path;
  if(role === ROLES.admin || role === ROLES.support){
    path = '/admin';
  }else if(role === ROLES.careprovider){
    path = '/careprovider';
  }else{
    path = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: path + "/monitoring/ccm-tracking",
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* sendInvite(action) {
  const custom_param = {
    action: action,
    endpoint: "/careprovider/invite",
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* saveStaff(action) {
  let endpoint;
  if (action.payload && action.payload.isClient) {
    endpoint = "/client/careprovider/staff-direct";
    delete action.payload.isClient;
  } else if (action.payload && action.payload.careproviderId) {
    endpoint = "/admin/create-careprovider-staff";
  } else {
    endpoint = "/careprovider/staff";
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
  try {
    yield put({ type: "DO_GET_SHARED_ACCOUNT" });
  } catch (err) {
    // ignore
  }
}
export function* saveSupport(action) {
  const custom_param = {
    action: action,
    endpoint: "/admin/support",
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
  return;
}
export function* editSupportUser(action) {
  if (action.payload && action.payload._id) {
    const custom_param = {
      action: action,
      endpoint: "/admin/edit-support-user/" + encryptRequest(action.payload._id),
      successType: "",
      errorType: ""
    };
    yield call(reusableSimplePutRequest, custom_param);
  }
  return;
}
export function* saveUser(action) {
  let endpoint;
  let role = yield select(getRole);
  if (role === "support" || role === "admin") {
    delete action.payload.isClient;
    if (action.payload && action.payload.careproviderId) {
      endpoint = "/admin/create-careprovider-patient";
    } else if (action.payload && action.payload.isHomeHealthAgent) {
      endpoint = "/admin/home-health-agent";
    } else {
      if (action.payload && action.payload.careprovider) {
        endpoint = "/admin/careprovider-direct";
        delete action.payload.isCareProvider;
        delete action.payload.careprovider;
      } else {
        endpoint = "/admin/users";
        delete action.payload.careprovider;
      }
    }

    const custom_param = {
      action: action,
      endpoint: endpoint,
      successType: "",
      errorType: ""
    };
    yield call(reusableSimplePostRequest, custom_param);
    return;
  }
  if (action.payload && action.payload.isClient) {
    if (action.payload.isCareProvider) {
      endpoint = "/client/careprovider-direct";
      delete action.payload.isCareProvider;
      delete action.payload.isClient;
    } else {
      endpoint = "/client/users";
      delete action.payload.isClient;
    }
  } else {
    endpoint = "/careprovider/patient";
  }

  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* savePatientCCMAnswers(action) {
  let role = yield select(getRole);
  let endpoint;
  if (role === "support" || role === "admin") {
    endpoint = "/admin/patient/ccmanswers";
  } else {
    endpoint = "/careprovider/patient/ccmanswers";
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* addConditions(action) {
  const custom_param = {
    action: action,
    endpoint: "/careprovider/patient/add-conditions",
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* deleteCondition(action) {
  const custom_param = {
    action: action,
    endpoint:
      "/careprovider/patient/delete-condition/" +
      encryptRequest(action.payload.conditionid) +
      "/" +
      encryptRequest(action.payload.userid),
    successType: "",
    errorType: "",
    ruleCall: true
  };
  yield call(reusableSimpleDeleteRequest, custom_param);
}
export function* createCareProviderCondition(action) {
  const custom_param = {
    action: action,
    endpoint: `/admin/careprovider/saveCondition`,
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* updateCareProviderCondition(action) {
  const custom_param = {
    action: action,
    endpoint: `/admin/careprovider/updateCondition`,
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* deleteCareProviderCondition(action) {
  const custom_param = {
    action: action,
    endpoint: `/admin/careprovider/delete-condition/${encryptRequest(action.payload.conditionid)}`,
    successType: "",
    errorType: "",
    ruleCall: true
  };
  yield call(reusableSimpleDeleteRequest, custom_param);
}
export function* autoAddAllPatients(action) {
  let url = `/careprovider/staff/${encryptRequest(action.payload.staffId)}/auto-add-all-patients`;
  const custom_param = {
    action: action,
    endpoint: url,
    successType: "AUTO_ADD_ALL_PATIENTS_SUCCESS",
    errorType: ""
  };
  yield call(reusableSimplePostRequestWithoutPopUp, custom_param);
  // After successfully adding all patients on the server, refresh the
  // staff's patient list so the UI shows the latest assignments.
  try {
    yield put({ type: "DO_GET_ALL_STAFF_PATIENT_LIST", payload: { staffId: action.payload.staffId } });
    // refresh shared account list so UI reflects assignment counts/state
    yield put({ type: "DO_GET_SHARED_ACCOUNT" });
  } catch (err) {
    // ignore refresh errors
  }
}
export function* addOrDeleteStaffPatient(action) {
  let url;
  if (action.payload.isAdd) {
    url = `/careprovider/staff/${encryptRequest(action.payload.staffId)}/assign-user`;
    const custom_param = {
      action: action,
      endpoint: url,
      successType: "",
      errorType: ""
    };
    yield call(reusableSimplePostRequest, custom_param);
  } else {
    url = `/careprovider/staff/${encryptRequest(action.payload.staffId)}/delete-user/${encryptRequest(action.payload.user)}`;
    const custom_param = {
      action: action,
      endpoint: url,
      successType: "",
      errorType: ""
    };
    yield call(reusableSimpleDeleteRequest, custom_param);
  }
  // Refresh the staff's patient list so UI reflects new assignments immediately
  try {
    yield put({ type: "DO_GET_ALL_STAFF_PATIENT_LIST", payload: { staffId: action.payload.staffId } });
    // Also refresh the shared account list to keep header/summary in sync
    yield put({ type: "DO_GET_SHARED_ACCOUNT" });
  } catch (err) {
    // ignore refresh errors here
  }
}
export function* addOrDeleteExpectation(action) {
  let url;
  if (action.payload.isAdd) {
    url = `/careprovider/staff/${encryptRequest(action.payload.staffId)}/assign-expectations`;
    const custom_param = {
      action: action,
      endpoint: url,
      successType: "",
      errorType: ""
    };
    yield call(reusableSimplePostRequest, custom_param);
  } else {
    url = `/careprovider/staff/${encryptRequest(action.payload.staffId)}/delete-expectation/${encryptRequest(action.payload.expectationId)}/${encryptRequest(action.payload.expectationType)}`;
    const custom_param = {
      action: action,
      endpoint: url,
      successType: "",
      errorType: ""
    };
    yield call(reusableSimpleDeleteRequest, custom_param);
  }
  // After updating expectations, refresh shared account list and staff patient list
  try {
    yield put({ type: "DO_GET_ALL_STAFF_PATIENT_LIST", payload: { staffId: action.payload.staffId } });
    yield put({ type: "DO_GET_SHARED_ACCOUNT" });
  } catch (err) {
    // ignore
  }
}
export function* saveInbox(action) {
  yield put({
    type: "ONGOING_INBOX_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if(role === 'admin' || role === 'support'){
    path = '/admin';
  }else if(isClient){
    path = '/client';
  }else if(role == 'careprovider'){
    path = '/careprovider';
  }else{
    path = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: path + "/add-inbox-message",
    successType: SUBMIT_INBOX,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
function jsonToQueryString(json) {
  if (json) {
    return (
      "?" +
      Object.keys(json)
        .map(function (key) {
          return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
        })
        .join("&")
    );
  } else {
    return "/";
  }
}

export function* getUserReadings(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let path;
  delete action.payload.patientPath;
  delete action.payload.isClient;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
    const custom_param2 = {
      action: action,
      endpoint: "/careprovider/dexcom" + jsonToQueryString(action.payload),
      successType: GET_DEXCOMDATA,
      errorType: ""
    };
    yield call(reusableSimpleGetRequest, custom_param2);
  } else {
    path = "/patient/";

    const custom_param2 = {
      action: action,
      endpoint: "/patient/dexcom" + jsonToQueryString(action.payload),
      successType: GET_DEXCOMDATA,
      errorType: ""
    };
    yield call(reusableSimpleGetRequest, custom_param2);
  }
  yield put({
    type:"ONGOING_BOTH_READING_REQUEST",
    payload: true,
  })
  // For bodytrace readings api
  const custom_param3 = {
    action: action,
    endpoint: path + "getBodytraceReadings" + jsonToQueryString(action.payload),
    successType: GET_BODYTRACE,
    errorType: ""
  };
  const custom_param = {
    action: action,
    endpoint: path + "readings" + jsonToQueryString(action.payload),
    successType: GET_USER_READINGS,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
  yield call(reusableSimpleGetRequest, custom_param3);
}
export function* getPatientExpectationCarePlan(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let path;
  delete action.payload.patientPath;
  delete action.payload.isClient;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  } else {
    path = "/patient/";
  }
  const custom_param = {
    action: action,
    endpoint: path + "getExpectationByPatients" + jsonToQueryString(action.payload),
    successType: GET_PATIEN_EXPECTATION_CARE_PLAN,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}

export function* getUserDexcomGlucoseData(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let path;
  delete action.payload.patientPath;
  delete action.payload.isClient;
  if (isCareProvider) {
    path = "/careprovider/";
    const custom_param2 = {
      action: action,
      endpoint:
        "/careprovider/dexcom-glucose" + jsonToQueryString(action.payload),
      successType: GET_DEXCOM_GLUCOSE_DATA,
      errorType: ""
    };
    yield call(reusableSimpleGetRequest, custom_param2);
  }
}

export function* getCareProvidersList(action) {
  const custom_param = {
    action: action,
    endpoint: "/admin/careprovider-list/" + encryptRequest(action.payload.client),
    successType: GET_CAREPROVIDERS_LIST_SUCCESS,
    errorType: GET_CAREPROVIDERS_LIST_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}

export function* filterPopulation(action) {
  yield put({
    type:"ONGOING_POPULATION_REQUEST",
    payload: true,
  })
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let endpoint;

  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else {
    path = "/careprovider/";
  }
  // if (action.payload.filterType === "condition") {
    const custom_param = {
      action: action,
      endpoint: path + "population" + jsonToQueryString(action.payload),
      successType: SAVE_POPULATION,
      errorType: ""
    };
    yield call(reusableSimpleGetRequest, custom_param);
  // } else {
  //   const custom_param = {
  //     action: action,
  //     endpoint: path + "population" + jsonToQueryString(action.payload),
  //     successType: SAVE_POPULATION_EXCEPTION,
  //     errorType: ""
  //   };
  //   yield call(reusableSimpleGetRequest, custom_param);
  // }
}
export function* removePopulation(action) {
  yield put({
    type: REMOVE_POPULATION
  });
  yield put({
    type: REMOVE_POPULATION_EXCEPTION
  });
}
export function* getConditions(action) {
  let role = yield select(getRole);
  let endpoint;
  if (role === "support" || role === "admin") {
    endpoint =
      "/admin/get-careprovider-conditions/" + encryptRequest(action.payload.careproviderId);
    const custom_param = {
      action: action,
      endpoint: endpoint,
      successType: GET_CONDITIONS,
      errorType: ""
    };
    yield call(reusableSimpleGetRequest, custom_param);
  } else if (role != "patient") {
    endpoint = "/careprovider/conditions";
    const custom_param = {
      action: action,
      endpoint: endpoint,
      successType: GET_CONDITIONS,
      errorType: ""
    };
    yield call(reusableSimpleGetRequest, custom_param);
  }
}

export function* getPatientConditions(action) {
  yield put({
    type: "ONGOING_REQUEST_CARE_PLAN",
    payload: true
  });
  let role = yield select(getRole);
  let isCareProvider = yield select(getIsCareProvider);
  if (role === "support" || role === "admin") {
    const custom_param = {
      action: action,
      endpoint: "/admin/patient-conditions" + "/" + encryptRequest(action.payload.userid),
      successType: GET_PATIENT_CONDITIONS,
      errorType: ""
    };
    yield call(reusableSimpleGetRequest, custom_param);
  } else if (role != "patient") {
    const custom_param = {
      action: action,
      endpoint:
        "/careprovider/patient-conditions" + "/" + encryptRequest(action.payload.userid),
      successType: GET_PATIENT_CONDITIONS,
      errorType: ""
    };
    yield call(reusableSimpleGetRequest, custom_param);
  }
}

export function* getPatientCCMAnswers(action) {
  yield put({
    type: "ONGOING_REQUEST_FOR_CCM_QUESTION_SECTION",
    payload: true
  });
  let role = yield select(getRole);
  let isCareProvider = yield select(getIsCareProvider);
  let endpoint;
  if (role === "support" || role === "admin") {
    endpoint = "/careprovider/patient-ccm-answers" + "/" + encryptRequest(action.payload.userid);
  } else if (isCareProvider) {
    endpoint = "/careprovider/patient-ccm-answers" + "/" + encryptRequest(action.payload.userid);
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_PATIENT_CCM_ANSWERS,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}

export function* getProfile(action) {
  yield put({
    type: "ONGOING_PATIENT_PROFILE_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/profile/user";
    const custom_param = {
      action: action,
      endpoint: "/patient/profile",
      successType: GET_PROFILE2,
      errorType: ""
    };
    yield call(reusableSimpleGetRequest, custom_param);
  } else if (isClient) {
    path = "/client/";
  } else {
    if (action.payload && action.payload.authProfile) {
      const custom_param = {
        action: action,
        endpoint: "/patient/profile",
        successType: GET_PROFILE2,
        errorType: ""
      };
      yield call(reusableSimpleGetRequest, custom_param);
    } else {
      const custom_param = {
        action: action,
        endpoint: "/patient/profile",
        successType: GET_PROFILE,
        errorType: ""
      };
      yield call(reusableSimpleGetRequest, custom_param);
      const custom_param2 = {
        action: action,
        endpoint: "/patient/profile",
        successType: GET_PROFILE2,
        errorType: ""
      };
      yield call(reusableSimpleGetRequest, custom_param2);
    }
  }
}
export function* saveProfile(action) {
  let endpoint;
  if (action.payload && action.payload.isClient) {
    endpoint = "/client/user/profile";
  } else {
    endpoint = "/patient/profile";
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* saveClientDetails(action) {
  const custom_param = {
    action: action,
    endpoint: "/client/profile",
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* getClientDetails(action) {
  const custom_param = {
    action: action,
    endpoint: "/client/profile",
    successType: GET_PROFILE_CLIENT,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}

export function* getCareProviderPatients(action) {
  // yield put({
  //   type: GET_CAREPROVIDER_PATIENTS,
  //   payload: []
  // });

  let role = yield select(getRole);
  let endpoint;
  if (role === "support" || role === "admin") {
    endpoint =
      "/admin/careprovider/" + encryptRequest(action.payload.user) + "/patients-direct";
  } else {
    endpoint =
      "/client/careprovider/" + encryptRequest(action.payload.user) + "/patients-direct";
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_CAREPROVIDER_PATIENTS,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getCareProviderStaff(action) {
  let role = yield select(getRole);
  let endpoint;
  if (role === "support" || role === "admin") {
    endpoint =
      "/admin/careprovider/" + encryptRequest(action.payload.careproviderId) + "/staff-direct";
  } else {
    endpoint =
      "/client/careprovider/" + encryptRequest(action.payload.careproviderId) + "/staff-direct";
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_CAREPROVIDER_STAFF,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}

export function* sendPMSessionReport(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let endpoint;
  if (role === "support" || role === "admin") {
    endpoint = "/admin/fax-pm-sessions"; 
  } else if(isClient){
    endpoint = "/client/fax-pm-sessions"; 
  } else {
    endpoint = "/careprovider/fax-pm-sessions";
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: "",
    errorType: ""
  };
  yield call(reusableFaxPostRequestWithoutPopUp, custom_param);
}

export function* resetPatientPassword(action) {
  let role = yield select(getRole);
  let endpoint;

  endpoint = "/admin/reset-password";

  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* getNoReadings(action) {
  let role = yield select(getRole);
  let endpoint;

  endpoint = "/admin/no-readings";

  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_NO_READINGS,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getNewPatient(action) {
  let endpoint;
  endpoint = "/admin/new-patients";
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_NEW_PATIENT,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}

export function* getDashboardCounts(action) {
  yield put({
    type: "ONGOING_DASHBOARD_COUNTS_REQUEST",
    payload: true
  });
  let endpoint = "/admin/dashboard-counts";
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_DASHBOARD_COUNTS_SUCCESS,
    errorType: "GET_DASHBOARD_COUNTS_FAIL"
  };
  yield call(reusableSimpleGetRequest, custom_param);
  yield put({
    type: "ONGOING_DASHBOARD_COUNTS_REQUEST",
    payload: false
  });
}
export function* getClients(action) {
  let role = yield select(getRole);
  let endpoint;

  endpoint = "/admin/client-list";

  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_CLIENTS,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getSupport(action) {
  yield put({
    type: "ONGOING_GET_SUPPORT_USER_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let endpoint;

  endpoint = "/admin/support";
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_SUPPORTS,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getCareProviders(action) {
  yield put({
    type: "ONGOING_CAREPROVIDER_STAFF_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let endpoint;
  if (role === "support" || role === "admin") {
    endpoint = "/admin/careproviders-direct";
  } else {
    endpoint = "/client/careproviders-direct";
  }
  if(action.payload && action.payload?.isExpectation === false){
    endpoint = endpoint + "/" + encryptRequest('isExpectationNotRequired')
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_CAREPROVIDERS,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getUserRoleAndDetails(action){
   const endpoint = "/patient/get-user-details/" + encryptRequest(action.payload.user)
   const custom_param = {
     action: action,
     endpoint: endpoint,
     successType: GET_PROFILE_AND_ROLS,
     errorType: ""
   };
   yield call(reusableSimpleGetRequest, custom_param);
 }
export function* getPatientProfile(action) {
  yield put({
    type: "ONGOING_PATIENT_PROFILE_REQUEST",
    payload: true
  });
  let endpoint;
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);

  let path;
  if (role == 'admin' || role == 'support') {
    path = "/admin/profile/user";
  } else if (isClient) {
    path = "/client/profile/user";
  } else if (role == 'careprovider') {
    path = "/careprovider/profile/";
  } else {
    path = "/patient/profile/";
  }
  if (action.payload && action.payload.isClient) {
    endpoint = path + jsonToQueryString(action.payload);
  } else {
    endpoint = path + jsonToQueryString(action.payload);
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_PROFILE,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getGlobalThresholdCareProvider(action) {
  yield put({
    type: "ONGOING_CARE_PROVIDER_THRESHOLD_REQUEST",
    payload: true
  });
  let endpoint;
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if(role == 'admin' || role == 'support'){
    path = "/admin/get-global-threshold-details";
  }else if(isClient){
    path = "/client/get-global-threshold-details";
  }else if(role == 'careprovider'){
    path = "/careprovider/get-global-threshold-details";
  }else{
    path = "/patient/get-global-threshold-details";
  }
  if (action.payload && action.payload.isClient) {
    endpoint = path + jsonToQueryString(action.payload);
  } else {
    endpoint = path + jsonToQueryString(action.payload);
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: GET_GLOBAL_THRESHOLD_CARE_PROVIDER,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* removeProfileData(action) {
  yield put({
    type: GET_PROFILE,
    payload: { data: null }
  });
}

export function* savePatientPermission(action) {
  let endpoint;

  if (action.payload && action.payload.isAdmin) {
    endpoint = "/admin/patient/offer-permission-direct";
  } else {
    endpoint = "/client/patient/offer-permission-direct";
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* saveProfileLogs(action) {
  let endpoint;
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);

  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/confirmed-info";
  } else if (isClient) {
   // path = "/client/user/profile";
  } else {
    path = "/careprovider/confirmed-info";
  }  
  const custom_param = {
    action: action,
    endpoint: path,
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* savePatientProfile(action) {
  //console.log('here save');
  yield put({
    type: "ONGOING_PATIENT_PROFILE_SAVE_REQUEST",
    payload: true
  });
  let endpoint;
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/user/profile";
  } else if (isClient) {
    path = "/client/user/profile";
  } else {
    path = "/careprovider/profile";
  }
  if (action.payload && action.payload.isClient) {
    endpoint = "/client/user/profile";
  } else {
    endpoint = "/careprovider/profile";
  }
  const custom_param = {
    action: action,
    endpoint: path,
    successType: SAVE_PROFILE,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
// Uplaod user image
export function* uploadUserImage(action){
  yield put({
    type: "ONGOING_PATIENT_PROFILE_SAVE_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/profile-image-upload";
  } else if (isClient) {
    path = "/client/profile-image-upload";
  } else if(role === "patient"){
    path = "/patient/profile-image-upload";
  }else {
    path = "/careprovider/profile-image-upload";
  }

  const custom_param = {
    action: action,
    endpoint: path,
    successType: SAVE_PROFILE_IMAGE,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
// Users version reports gets
export function* versionReports(action){
  yield put({
    type: "ONGOING_NOTIFICATION_LOGS_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/version-report";
  }
  let url = path + jsonToQueryString(action.payload);

  const custom_param = {
    action: action,
    endpoint: url,
    successType: GET_VERSION_REPORTS_SUCCESS,
    errorType: "GET_VERSION_REPORTS_FAIL"
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
// Users version reports gets
export function* versionReportsExport(action){
  yield put({
    type: "ONGOING_VERSION_REPORT_EXPORT_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/version-report-export";
  }
  let url = path + jsonToQueryString(action.payload);

  const custom_param = {
    action: action,
    endpoint: url,
    successType: GET_VERSION_REPORTS_EXPORT_SUCCESS,
    errorType: "GET_VERSION_REPORTS_FAIL"
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
// App verions get
export function* getAppVersions(action){
  let role = yield select(getRole);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/get-app-version";
  }
  let url = path;

  const custom_param = {
    action: action,
    endpoint: url,
    successType: GET_APP_VERSION_REPORTS,
    errorType: "GET_VERSION_REPORTS_FAIL"
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
// sent update app notification
export function* sentUpdateAppNotification(action){
  let role = yield select(getRole);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/sent-update-app-notification";
  }
  let url = path;

  const custom_param = {
    action: action,
    endpoint: url,
    successType: SENT_APP_UPDATE_NOTIFICATION,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
/**
 * Update user signature's
 */
export function* updateSignature(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if (role == 'admin' || role == 'support') {
    path = "/admin/update-signature";
  } else if (isClient) {
    path = "/client/update-signature";
  } else if (role == 'careprovider') {
    path = "/careprovider/update-signature";
  } else {
    path = "/patient/update-signature";
  }
  const custom_param = {
    action: action,
    endpoint: path,
    successType: UPDATE_SIGNATURE,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* changePassword(action) {
  const custom_param = {
    action: action,
    endpoint: "/patient/change-password",
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}

export function* getDevices(action) {
  yield put({
    type: "ONGOING_GET_DEVICE_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path = "";
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if(role === "careprovider"){
    path = "/careprovider/";
  } 
  const custom_param = {
    action: action,
    endpoint: path + "patient/devices" + jsonToQueryString(action.payload),
    successType: GET_DEVICES,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getPatientCCMSubmission(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path = "";
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if(role === "careprovider"){
    path = "/careprovider/";
  } 
  const custom_param = {
    action: action,
    endpoint: path + "get-patient-ccm-submission" + jsonToQueryString(action.payload),
    successType: GET_CCM_SUBMISSION,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getPMTime(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);

  let endpoint;
  yield put({
    type: RESET_CCM,
    payload: ""
  });

  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else {
    path = "/careprovider/";
  }
  const custom_param = {
    action: action,
    endpoint:
      path + "monitoring/ccm-tracking" + jsonToQueryString(action.payload),
    successType: GET_PM_RECORD,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getPMTimeNew(action) {
  yield put({
    type: GET_REMOVE_CCM_PATH,
    payload: undefined
  });
  yield put({
    type: "ONGOING_PM_SESSION_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);

  let endpoint;
  yield put({
    type: RESET_CCM,
    payload: ""
  });

  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else {
    path = "/careprovider/";
  }
  const custom_param = {
    action: action,
    endpoint:
      path + "monitoring/ccm-tracking-new" + jsonToQueryString(action.payload),
    successType: GET_PM_RECORD_NEW,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
/**
 * Fetch Shared and Family Account patient details
 * @param {*} action 
 */
export function* getSharedAccount(action) {
  yield put({
    type: "ONGOING_SHARED_ACCOUNT_LIST_REQUEST",
    payload: true
  });
  let endpoint;
  let reducerType;
  let role = yield select(getRole);
  if(role == 'admin' || role == 'support'){
    endpoint = "/admin/shared-family-account" + jsonToQueryString(action.payload);
    reducerType = GET_SHARED_ACCOUNT_LIST;
  } else{
    endpoint = "/careprovider/shared-family-account";
    reducerType = GET_SHARED_ACCOUNT_LIST;
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: reducerType,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getStaff(action) {
  let endpoint;
  let reducerType;
  let role = yield select(getRole);
  if (action.payload && action.payload.isClient) {
    endpoint = action.payload.isAll
      ? "/client/staff-direct"
      : "/client/careprovider/" + encryptRequest(action.payload.user) + "/staff-direct";
    reducerType = action.payload.isAll
      ? GET_STAFF_CLIENT
      : GET_CAREPROVIDER_STAFF;
  } else {
    if(role == 'admin' || role == 'support'){
      endpoint = "/admin/staff-list";
      reducerType = GET_STAFF_LIST;
    }else{
      endpoint = "/careprovider/staff";
      reducerType = GET_STAFF_LIST;
    }
  }
  const custom_param = {
    action: action,
    endpoint: endpoint,
    successType: reducerType,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getStaffList(action) {
  let endpoint;
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  if(role == 'admin' || role == 'support'){
    endpoint = "/admin";
  }else if(isClient){
    endpoint = "/client";
  }else if(role == 'careprovider'){
    endpoint = "/careprovider";
  }else{
    endpoint = "/patient";
  }
  const custom_param = {
    action: action,
    endpoint: endpoint + '/staff-list',
    successType: GET_STAFF_LIST,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getPatientList(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let endpoint;
  if(role == 'admin' || role == 'support'){
    endpoint = '/admin';
  }else if(isClient){
    endpoint = '/client'; 
  }else if(role == 'careprovider'){
    endpoint = '/careprovider';
  }else{
    endpoint = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: endpoint + '/patient-list',
    successType: GET_PATIENT_LIST,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getAdminList(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let endpoint;
  if(role == 'admin' || role == 'support'){
    endpoint = '/admin';
  }else if(isClient){
    endpoint = '/client'; 
  }else if(role == 'careprovider'){
    endpoint = '/careprovider';
  }else{
    endpoint = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: endpoint + '/admin-list',
    successType: GET_ADMIN_LIST,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getAdditionalCareProviderList(action){
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  yield put({
    type: "ONGOING_ASSIGNED_CAREPROVIDER_REQUEST",
    payload: true
  });
  if(role === 'admin' || role === 'support'){
    path = '/admin';
  }else if(isClient){
    path = '/client';
  }else if(role == 'careprovider'){
    path = '/careprovider';
  }else{
    path = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: path + "/additional-careprovider-list" + jsonToQueryString(action.payload),
    successType: GET_ADDITIONAL_CAREPROVIDER_LIST,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* exportSharedAccountList(action){
  let endpoint;
  let role = yield select(getRole);
  if (role === "support" || role === "admin") {
    endpoint = "/admin/export-shared-accounts";
  }
  const custom_param = {
    endpoint: endpoint,
    successType: GET_EXPORT_ALL_SHARED_ACCOUNT
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getAllStaffPatientList(action) {
  let endpoint;
  let role = yield select(getRole);
  yield put({
    type: "ONGOING_ASSIGNED_USER_REQUEST",
    payload: true
  });
  // build querystring from payload excluding staffId
  const qp = Object.assign({}, action.payload);
  delete qp.staffId;
  let qs = jsonToQueryString(qp);
  if (qs === "/") qs = "";
  if (role === "support" || role === "admin") {
    endpoint = "/admin/all-staff-patient-list/" + encryptRequest(action.payload.staffId) + qs;
  } else if (role === "careprovider") {
    endpoint = "/careprovider/all-staff-patient-list/" + encryptRequest(action.payload.staffId) + qs;
  }
  const custom_param = {
    endpoint: endpoint,
    successType: GET_ALL_STAFF_PATIENT_LIST,
    errorType: GET_ALL_STAFF_PATIENT_LIST_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* saveShared(action) {
  let endpoint;
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  if(role === 'admin' || role === 'support'){
    endpoint = '/admin';
  }else if(isClient){
    endpoint = '/client';
  }else if(role == 'careprovider'){
    endpoint = '/careprovider';
  }else{
    endpoint = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: endpoint + '/shared',
    successType: SAVE_FAMILY_SHARED_ACCOUNT,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* deleteAllStaffPatient(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if(role === 'admin' || role === 'support'){
    path = '/admin';
  }else if(isClient){
    path = '/client';
  }else if(role == 'careprovider'){
    path = '/careprovider';
  }else{
    path = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: path + `/remove-all-assigned-patients/${encryptRequest(action.payload.staffId)}`,
    successType: DELETE_ALL_STAFF_PATIENTS,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
  try {
    // refresh shared accounts list and staff-specific list after delete-all
    yield put({ type: "DO_GET_SHARED_ACCOUNT" });
    yield put({ type: "DO_GET_ALL_STAFF_PATIENT_LIST", payload: { staffId: action.payload.staffId } });
  } catch (err) {
    // ignore
  }
}
export function* addOrUpdateMainCarepoviderStaff(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if(role === 'admin' || role === 'support'){
    path = '/admin';
  }else if(isClient){
    path = '/client';
  }else if(role == 'careprovider'){
    path = '/careprovider';
  }else{
    path = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: path + "/save-additional-careprovider",
    successType: SAVE_MAINCAREPROVIDER,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* removeAllAssignedCareprovider(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if(role === 'admin' || role === 'support'){
    path = '/admin';
  }else if(isClient){
    path = '/client';
  }else if(role == 'careprovider'){
    path = '/careprovider';
  }else{
    path = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: path + "/remove-all-assigned-careprovider/" + encryptRequest(action.payload.staffId),
    successType: REMOVE_ALL_ASSIGNED_CAREPROVIDER,
    errorType: ""
  };
  yield call(reusableSimpleDeleteRequest, custom_param);
}
export function* getCareProviderList(action){
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let endpoint;
  if(role == 'admin'|| role == 'support'){
    endpoint = '/admin';
  }else if(role == 'careprovider'){
    endpoint = '/careprovider';
  }else if(isClient){
    endpoint = '/client';
  }else{
    endpoint = '/patient';
  }
  const custom_param = {
    action:action,
    endpoint: endpoint + '/careprovider-list',
    successType: GET_CAREPROVIDER_LIST,
    errorType:""
  }
  yield call(reusableSimpleGetRequest,custom_param);
}
export function* getClientList(action){
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let endpoint;
  if(role == 'admin'|| role == 'support'){
    endpoint = '/admin';
  }else if(isClient){
    endpoint = '/client';
  }
  const custom_param = {
    action:action,
    endpoint: endpoint + '/client-list-new',
    successType: GET_CLIENT_LIST,
    errorType:""
  }
  yield call(reusableSimpleGetRequest,custom_param);
}
export function* getInbox(action) {
  yield put({
    type: "ONGOING_INBOX_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let endpoint;
  if(role == 'admin' || role == 'support'){
    endpoint = '/admin';
  }else if(isClient){
    endpoint = '/client';
  }
  else if(role == 'careprovider'){
    endpoint = '/careprovider';
  }
  else{
    endpoint = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: endpoint + '/inbox-list' + jsonToQueryString(action.payload),
    successType: GET_INBOX,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getThirtyDaysSummaryPatient(action) {
  yield put({
    type: "ONGOING_THIRTY_DAYS_REQUEST",
    payload: true
  });  
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/getThirtyDaySummary" + jsonToQueryString(action.payload);
  } else if (isClient) {    
    path = "/client/getThirtyDaySummary" + jsonToQueryString(action.payload);
  } else if (isCareProvider) {    
    path = "/careprovider/getThirtyDaySummary" + jsonToQueryString(action.payload);
  } else {
    path = "/patient/getThirtyDaySummary" + jsonToQueryString(action.payload);
  }
  const custom_param = {
    action: action,
    endpoint: path,
    successType: GET_THIRTY_DAY_SUMMARY,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
/**
 * Fetched the ccm form submission details by the patient id
 * @param {*} action patient details
 */
export function* getPatientSubmissionDetails(action) {
  yield put({
    type: "ONGOING_SUBMISSION_REQUEST",
    payload: true
  });
  const custom_param = {
    action: action,
    endpoint: "/patient/get-patient-submission-details" + jsonToQueryString(action.payload),
    successType: GET_PATIENT_SUBMISSION_DETAILS,
    errorType: GET_PATIENT_SUBMISSION_DETAILS_ERROR
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* saveTimeAdherenceRule(action) {
  const custom_param = {
    action: action,
    endpoint: "/patient/rules/time-adherence",
    successType: GET_RULES_SET_BY_OTHERS_SUCCESS,
    errorType: GET_RULES_SET_BY_OTHERS_FAIL
  };
  if (action.payload._id) {
    custom_param.endpoint =
      "/patient/rules" +
      "/" +
      encryptRequest(action.payload._id) +
      "/" +
      encryptRequest(action.payload.ruleType);
    yield call(reusableSimplePutRequest, custom_param);
    return;
  }
  yield call(reusableSimplePostRequest, custom_param);
}
export function* saveAdherenceRule(action) {
  const custom_param = {
    action: action,
    endpoint: "/patient/rules/adherence",
    successType: GET_RULES_SET_BY_OTHERS_SUCCESS,
    errorType: GET_RULES_SET_BY_OTHERS_FAIL
  };
  if (action.payload._id) {
    custom_param.endpoint =
      "/patient/rules" +
      "/" +
      encryptRequest(action.payload._id) +
      "/" +
      encryptRequest(action.payload.ruleType);
    yield call(reusableSimplePutRequest, custom_param);
    return;
  }
  yield call(reusableSimplePostRequest, custom_param);
}
export function* saveReminderRule(action) {
  const custom_param = {
    action: action,
    endpoint: "/patient/rules/reminder",
    successType: GET_RULES_SET_BY_OTHERS_SUCCESS,
    errorType: GET_RULES_SET_BY_OTHERS_FAIL
  };
  if (action.payload._id) {
    custom_param.endpoint =
      "/patient/rules" +
      "/" +
      encryptRequest(action.payload._id) +
      "/" +
      encryptRequest(action.payload.ruleType);
    yield call(reusableSimplePutRequest, custom_param);
    return;
  }
  yield call(reusableSimplePostRequest, custom_param);
}
export function* saveWeightRule(action) {
  const custom_param = {
    action: action,
    endpoint: "/patient/rules/weight-difference",
    successType: GET_RULES_SET_BY_OTHERS_SUCCESS,
    errorType: GET_RULES_SET_BY_OTHERS_FAIL
  };
  if (action.payload._id) {
    custom_param.endpoint =
      "/patient/rules" +
      "/" +
      encryptRequest(action.payload._id) +
      "/" +
      encryptRequest(action.payload.ruleType);
    yield call(reusableSimplePutRequest, custom_param);
    return;
  }
  yield call(reusableSimplePostRequest, custom_param);
}

export function* saveTrendingViolationRule(action) {
  const custom_param = {
    action: action,
    endpoint: "/patient/rules/trending-violation",
    successType: GET_RULES_SET_BY_OTHERS_SUCCESS,
    errorType: GET_RULES_SET_BY_OTHERS_FAIL
  };
  if (action.payload._id) {
    custom_param.endpoint =
      "/patient/rules" +
      "/" +
      encryptRequest(action.payload._id) +
      "/" +
      encryptRequest(action.payload.ruleType);
    yield call(reusableSimplePutRequest, custom_param);
    return;
  }
  yield call(reusableSimplePostRequest, custom_param);
}
export function* updateQuestionnaire(action) {
  const custom_param = {
    action: action,
    endpoint: "careprovider/questionnaire",
    successType: GET_RULES_SET_BY_OTHERS_SUCCESS,
    errorType: GET_RULES_SET_BY_OTHERS_FAIL
  };
  if (action.payload._id) {
    custom_param.endpoint = "careprovider/questionnaire/" + encryptRequest(action.payload._id)      
    yield call(reusableSimplePutRequest, custom_param);
    return;
  }
  yield call(reusableSimplePostRequest, custom_param);
}
export function* getMyViolations(action) {
  yield put({
    type: "ONGOING_USER_VIOLATION_REQUEST",
    payload: true
  });
  const path = "/patient/violations/my-violations"+ jsonToQueryString(action.payload)
  const custom_param = {
    action: action,
    endpoint: path,
    successType: GET_MY_VIOLATIONS,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getViolationsPrintData(action) {
  yield put({
    type: ONGOING_USER_VIOLATION_REQUEST_PRINT,
    payload: true
  });
  const path = "/patient/violationsPrint" + jsonToQueryString(action.payload)
  const custom_param = {
    action: action,
    endpoint: path,
    successType: GET_USER_VIOLATION_PRINT,
    errorType: ""
  };

  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getUserViolationsRecordsCount(action) {
  try { 
    let role = yield select(getRole);
    let isClient = yield select(getIsClient);
    let isCareProvider = yield select(getIsCareProvider);
    let path;
    if (action.payload && action.payload.patientPath) {
      delete action.payload["patientPath"];
    }
    if (action.payload && action.payload.isClient) {
      delete action.payload["isClient"];
    }

    let query = "";
    if(action.payload && Object.keys(action.payload).length !== 0){
      query = jsonToQueryString(action.payload);
    }

    if (role === "support" || role === "admin") {
      path = "/admin/violations-counts/patient" + query;
    } else if (isClient) {
      path = "/client/violations-counts/patient" + query;
    } else if (isCareProvider) {
      path = "/patient/violations/users-violations-counts" + query;
    } else {
      path = "/patient/violations/my-violations-counts" + query;
    }
    const custom_param = {
      action: action,
      endpoint: path,
      successType: GET_USER_VIOLATIONS_RECORD_COUNT,
      errorType: ""
    };
    yield call(reusableSimpleGetRequest, custom_param);
  } catch (error) {
    console.log(error);
  }
}
export function* exportUserViolation(action) {
  try {
    yield put({
      type: "ONGOING_USER_VIOLATION_CSV_EXPORT_REQUEST",
      payload: true
    });

    let role = yield select(getRole);
    let isClient = yield select(getIsClient);
    let isCareProvider = yield select(getIsCareProvider);

    let path;
    if (action.payload && action.payload.patientPath) {
      delete action.payload["patientPath"];
    }
    if (action.payload && action.payload.isClient) {
      delete action.payload["isClient"];
    }

    if (role === "support" || role === "admin") {
      path = "/admin/exportUserExceptionCSV/" + action.payload.patientId + jsonToQueryString(action.payload);
    } else if (isClient) {
      path = "/client/exportUserExceptionCSV/" + action.payload.patientId + jsonToQueryString(action.payload);
    } else if (isCareProvider) {
      path = "/patient/exportUserExceptionCSV" + jsonToQueryString(action.payload);
    } else {
       if(action.payload.isPatient){
        path = "/patient/exportMyExceptionCSV" + jsonToQueryString(action.payload);
       }
    }

    const custom_param = {
      action: action,
      endpoint: path,
      successType: EXPORT_USER_VIOLATIONS_CSV_EXPORT,
      errorType: ""
    };
    yield call(reusableSimpleGetRequest, custom_param);
  } catch (error) {
    
  }
}
export function* getMyQuestionnaire(action) {
  yield put({
    type: "ONGOING_REQUEST_QUESTIONNAIRE",
    payload: true
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let endpoint;

  let path;
  if (isClient) {
    path = "/client/";
  } else {
    path = "/careprovider/";
  }

  const custom_param = {
    action: action,
    endpoint: path+"questionnaire/createdQuestionnaire"+jsonToQueryString(action.payload),
    successType: GET_MY_QUESTIONNAIRES,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getMyQuestionnaireNameAndRepeted(action) {
  let isClient = yield select(getIsClient);
  let path;
  if (isClient) {
    path = "/client/";
  } else {
    path = "/careprovider/";
  }
  const custom_param = {
    action: action,
    endpoint: path+"questionnaire/getQuestionnaireNameAndRepetedList?patientId=" + action.payload.patientId,      
    successType: GET_MY_QUESTIONNAIRES_NAME_REPETED,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getMyQuestionnaireCareProvider(action) {
  const custom_param = {
    action: action,
    endpoint: "/careprovider/questionnaire/created",
    successType: GET_MY_QUESTIONNAIRES_CARE_PROVIDER_SUCCESS,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getUserViolations(action) {
  try {
    yield put({
      type: "ONGOING_USER_VIOLATION_REQUEST",
      payload: true
    });
    let role = yield select(getRole);
    let isClient = yield select(getIsClient);
    let isCareProvider = yield select(getIsCareProvider);
    let path;
    if (action.payload && action.payload.patientPath) {
      delete action.payload["patientPath"];
    }
    if (action.payload && action.payload.isClient) {
      delete action.payload["isClient"];
    }

    if (role === "support" || role === "admin") {
      path = "/admin/violations/patient/" + encryptRequest(action.payload.patientId) + jsonToQueryString(action.payload);
    } else if (isClient) {
      path = "/client/violations/patient/" + encryptRequest(action.payload.patientId) + jsonToQueryString(action.payload);
    } else if (isCareProvider) {
      path = "/patient/violations/users-violations" + jsonToQueryString(action.payload);
    } else {
      path = "/patient/violations/users-violations" + jsonToQueryString(action.payload);
    }
    const custom_param = {
      action: action,
      endpoint: path,
      successType: GET_USER_VIOLATIONS,
      errorType: ""
    };
    yield call(reusableSimpleGetRequest, custom_param);
  } catch (error) {
    
  }
}
export function* deleteRule(action) {
  const custom_param = {
    action: action,
    endpoint:
      "/patient/rules" +
      "/" +
      encryptRequest(action.payload.id) +
      "/" +
      encryptRequest(action.payload.ruleType),
    successType: "",
    errorType: "",
    ruleCall: true
  };
  yield call(reusableSimpleDeleteRequest, custom_param);
}
/**
 * Delete questionnaire by id
 * @param {*} action 
 */
export function* deleteQuestionnaire(action) {
  const custom_param = {
    action: action,
    endpoint: "careprovider/questionnaire/" + encryptRequest(action.payload.id),
    successType: "",
    errorType: "",
    ruleCall: true
  };
  yield call(reusableSimpleDeleteRequest, custom_param);
}
export function* deleteStaff(action) {
  const custom_param = {
    action: action,
    endpoint: "/careprovider/staff" + "/" + encryptRequest(action.payload.id),
    successType: "",
    errorType: ""
  };
  yield call(reusableSimpleDeleteRequest, custom_param);
  try {
    yield put({ type: "DO_GET_SHARED_ACCOUNT" });
  } catch (err) {
    // ignore
  }
}
export function* deleteDevice(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);

  let endpoint;

  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/direct/";
  } else if (isClient) {
    path = "/client/direct/";
  } else if(role == 'careprovider'){
    path = "/careprovider/";
  } else{
    path = "/patient/";
  }
  let custom_param;
  if (action.payload.isPatient) {
    custom_param = {
      action: action,
      endpoint:
        path +
        "patient" +
        "/" +
        encryptRequest(action.payload.deviceUser) +
        "/device/" +
        encryptRequest(action.payload.deviceId),
      successType: "",
      errorType: ""
    };
  } else {
    custom_param = {
      action: action,
      endpoint: "/patient/device/" + encryptRequest(action.payload.deviceId),
      successType: "",
      errorType: ""
    };
  }

  yield call(reusableSimpleDeleteRequest, custom_param);
}

export function* readInbox(action) {
  let endpoint;
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  if(role == 'admin' || role == 'support'){
    endpoint = '/admin';
  }else if(isClient){
    endpoint = '/client';
  }else if(role == 'patient'){
    endpoint = '/patient';
  }else{
    endpoint = '/careprovider';
  }  
  if(action.payload.inboxList){
    const model = {
      status:true,      
      message: "success",
      unReadCount: action.payload.unReadCount,
      totalRecode: 0,
      inboxMessages: [],      
    }
    yield put({
      type: GET_INBOX,
      payload: model
    });
    const model1 = {
      status:true,      
      message: "success",
      unReadCount: action.payload.unReadCount,
      totalRecode: action.payload.totalRecode,
      inboxMessages: action.payload.inboxList,      
    }
    yield put({
      type: GET_INBOX,
      payload: model1
    });
  }
  const custom_param = {
    action: action,
    endpoint: endpoint + '/read-inbox/' + encryptRequest(action.payload.id),
    successType: READ_INBOX_SUCCESS,
    errorType: ""
  };
  yield call(reusableSimplePutRequest, custom_param);
}
export function* getInboxUnreadCount(action) {
  const token = yield select(getToken);
  if (!token) {
    return;
  }

  let endpoint;
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  if(role == 'admin' || role == 'support'){
    endpoint = '/admin';
  }else if(isClient){
    endpoint = '/client';
  }else if(role == 'careprovider'){
    endpoint = '/careprovider';
  }else{
    endpoint = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: endpoint + '/unread-count',
    successType: GET_UNREAD_INBOX_COUNT,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* readAllInbox(action) {
  let endpoint;
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  if(role == 'admin'){
    endpoint = '/admin';
  }else if(isClient){
    endpoint = '/client';
  }else if(role == 'patient'){
    endpoint = '/patient';
  }else{
    endpoint = '/careprovider';
  }
  
  const custom_param = {
    action: action,
    endpoint: endpoint + '/read-all-inbox' ,
    successType: READ_ALL_INBOX_SUCCESS,
    errorType: ""
  };
  yield call(reusableSimplePutRequest, custom_param);
}
export function* deleteUser(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  }
  const custom_param = {
    action: action,
    endpoint: path + "user-action-direct" + "/" + encryptRequest(action.payload.user),
    successType: "",
    errorType: ""
  };
  yield call(reusableSimpleDeleteRequest, custom_param);
}
export function* disableUser(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  }
  const custom_param = {
    action: action,
    endpoint: path + "user-action-direct" + "/" + encryptRequest(action.payload.user),
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePutRequest, custom_param);
}
export function* disableDemoUser(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  }
  const custom_param = {
    action: action,
    endpoint: path + "user-demo-action-direct/" + encryptRequest(action.payload.user),
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePutRequest, custom_param);
}
export function* enableUser(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  }
  const custom_param = {
    action: action,
    endpoint:
      path + "user-action-direct" + "/" + encryptRequest(action.payload.user) + "?enable=true",
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePutRequest, custom_param);
}

export function* approvedUser(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  }
  const custom_param = {
    action: action,
    endpoint:
      path + "user-approval" + "/" + encryptRequest(action.payload.user) + "?approved=true",
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePutRequest, custom_param);
}

export function* rejectedUser(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  }
  const custom_param = {
    action: action,
    endpoint:
      path + "user-approval" + "/" + encryptRequest(action.payload.user) + "?rejected=true",
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePutRequest, custom_param);
}


export function* enableDemoUser(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  }
  const custom_param = {
    action: action,
    endpoint:
      path + "user-demo-action-direct/" + encryptRequest(action.payload.user) + "?enable=true",
    successType: "",
    errorType: ""
  };
  yield call(reusableSimplePutRequest, custom_param);
}
export function* deleteInbox(action) {
  let endpoint;
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  if(role == 'admin'){
    endpoint = '/admin';
  }else if(isClient){
    endpoint = '/client';
  }else if(role == 'patient'){
    endpoint = '/patient';
  }else{
    endpoint = '/careprovider';
  }
  const custom_param = {
    action: action,
    endpoint: endpoint + '/delete-inbox/' + encryptRequest(action.payload.id),
    successType: DELETE_INBOX_SUCCESS,
    errorType: ""
  };
  yield call(reusableSimpleDeleteRequest, custom_param);
}
export function* deleteAllInbox(action){
  let endpoint;
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  if(role == 'admin'){
    endpoint = '/admin';
  }else if(isClient){
    endpoint = '/client';
  }else if(role == 'patient'){
    endpoint = '/patient';
  }else{
    endpoint = '/careprovider';
  }
  const custom_param = {
    action : action,
    endpoint: endpoint + '/delete-all-inbox',
    successType: DELETE_ALL_INBOX_SUCCESS,
    errorType: ""
  };
  yield call(reusableSimpleDeleteRequest,custom_param);
}
export function* getNotes(action) {
  yield put({
    type: "ONGOING_NOTE_LIST_REQUEST",
    payload: true
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let endpoint;

  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  } else {
    path = "/patient/";
  }

  const custom_param = {
    action: action,
    endpoint: path + "notes/" + encryptRequest(action.payload.userid),
    successType: "GET_USER_NOTES",
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getPmSessionTime(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let endpoint;
  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  } else {
    path = "/patient/";
  }
  const custom_param = {
    action: action,    
    endpoint: path + "get-patient-rpm-ccm-time" + jsonToQueryString(action.payload),
    successType: GET_USER_PMSESSION_TIME,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getOnBoardingCategories(action) {
  const custom_param = {
    action: action,
    endpoint: "/careprovider/getOnBoardingCategories",
    successType: "GET_ON_BOARDING_STATUS",
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* deleteNotes(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let endpoint;

  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  } else {
    path = "/patient/";
  }
  const custom_param = {
    action: action,
    endpoint: path + "note" + "/" + encryptRequest(action.payload.id),
    successType: "",
    errorType: ""
  };
  yield call(reusableSimpleDeleteRequest, custom_param);
}
export function* deleteReading(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let endpoint;

  let path = "/admin/";
  const custom_param = {
    action: action,
    endpoint: path + "reading" + "/" + encryptRequest(action.payload.id),
    successType: "",
    errorType: ""
  };
  yield call(reusableSimpleDeleteRequest, custom_param);
}
export function* editNotes(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let endpoint;

  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  } else {
    path = "/patient/";
  }
  const custom_param = {
    action: action,
    endpoint: path + "/note" + "/" + encryptRequest(action.payload.id),
    successType: "",
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* savePatientFrequency(action){
  yield put({
    type:"ONGOING_TESTING_FREQUENCY_REQUEST",
    payload: true,
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);

  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  } else {
    path = "/patient/";
  }
  const custom_param = {
    action: action,
    endpoint: path + "/add-frequency",
    successType: SUBMIT_TESTING_FREQUENCY,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* saveProfileConfigration(action){
  yield put({
    type:"ONGOING_SAVE_PROFILE_REQUEST",
    payload: true,
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);

  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  } else {
    path = "/patient/";
  }
  const custom_param = {
    action: action,
    endpoint: path + "save-configration",
    successType: SUBMIT_PROFILE_CONFIGRATION,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* getPatientReportSchedularConfiguration(action){
  yield put({
    type:"ONGOING_GET_PATIENT_REPORT_SCHEDULAR_CONFIG",
    payload: true,
  });
  let path = '/patient/';
  const custom_param = {
    action: action,
    endpoint: path + "reportSchedularConfiguration" + jsonToQueryString(action.payload),
    successType: PATIENT_REPORT_SCHEDULAR_CONFIG,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* savePatientReportSchedularConfiguration(action){
  yield put({
    type:"ONGOING_GET_PATIENT_REPORT_SCHEDULAR_CONFIG",
    payload: true,
  });

  let path = "/patient/";
  const custom_param = {
    action: action,
    endpoint: path + "saveReportSchedularConfiguration",
    successType: SUBMIT_REPORT_SCHEDULAR_CONFIG,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* saveProfileConfigrationNotify(action){
  yield put({
    type:"ONGOING_SAVE_PROFILE_REQUEST",
    payload: true,
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);

  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  } else {
    path = "/patient/";
  }
  const custom_param = {
    action: action,
    endpoint: path + "save-notify-configration",
    successType: SUBMIT_PROFILE_CONFIGRATION_NOTIFY,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* getPatientFrequency(action){
  yield put({
    type:"ONGOING_TESTING_FREQUENCY_REQUEST",
    payload: true,
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);

  let path;
  if (role === "support" || role === "admin") {
    path = "/admin";
  } else if (isClient) {
    path = "/client";
  } else if (isCareProvider) {
    path = "/careprovider";
  } else {
    path = "/patient";
  }
  const custom_param = {
    action: action,
    endpoint: path + "/get-reading-frequency" + jsonToQueryString(action.payload),
    successType: GET_PATIENT_FREQUENCY,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getProfileDefaultConfigration(action){
  yield put({
    type: "ONGOING_SAVE_PROFILE_REQUEST",
    payload: true
  });
  const custom_param = {
    action: action,
    endpoint: "/admin/get-profile-default-congigration" + jsonToQueryString(action.payload),
    successType: GET_DEFAULT_PROFILE_CONFIGRATION,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getProfileVerbalAndWelcomeNotes(action){
  const custom_param = {
    action: action,
    endpoint: "/patient/verbalAndWelcomeNotes" + jsonToQueryString(action.payload),
    successType: GET_PATIENT_VERBAL_WELCOME_NOTES,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* saveNotes(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let isCareProvider = yield select(getIsCareProvider);
  let endpoint;

  let path;
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (isCareProvider) {
    path = "/careprovider/";
  } else {
    path = "/patient/";
  }
  const custom_param = {
    action: action,
    endpoint: path + "note",
    successType: "",
    errorType: "",
    hideErrorToast: true
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* getVideoToken(action) {
  const custom_param = {
    action: action,
    endpoint: "/patient/video-token",
    successType: "GET_VIDEO_TOKEN",
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* timerStarts(action) {
  yield put({
    type: TIMER_STARTS,
    payload: action.payload
  });
}
export function* exportReadingRecordsList(action){
  let endpoint;
  yield put({
    type:"ONGOING_PDF_EXCEL_READING_REQUEST",
    payload: true,
  })
  endpoint = "/admin/exportPatientReport";
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_EXPORT_READING_RECODES
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* exportAdminPatientPopulateList(action){
  yield put({
    type:"ONGOING_POPULATION_DATA_REQUEST",
    payload: true,
  })
  let endpoint = "/admin/export-patient-populate";
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_EXPORT_PATIENT_POPULATE_REPORT
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* exportCareProviderPatientPopulateList(action){
  yield put({
    type:"ONGOING_POPULATION_DATA_REQUEST",
    payload: true,
  })
  let endpoint = "/careprovider/export-patient-populate";
  const custom_param = {
    endpoint: endpoint + jsonToQueryString(action.payload),
    successType: GET_EXPORT_PATIENT_POPULATE_REPORT
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* emailReadingReport(action) {  
  let path = 'patient';
  const custom_param = {
    action: action,
    endpoint: path + "/fax-web",
    successType: GET_CURRENT_MONTH_REPORT_SUCCESS,
    errorType: ""
  };
  yield call(reusableSimplePostRequest, custom_param);
}
export function* getCareproviderOrganizations(action){
  yield put({
    type: ONGOING_GET_CAREPROVIDER_ORGANIZATION_REQUEST,
    payload: true
  });
  const custom_param = {
    action: action,
    endpoint: "/admin/get-organization-careprovider",
    successType: GET_CAREPROVIDER_ORGANIZATION,
    errorType: ""
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* getRPMCarePlanInformation(action){
  yield put({
    type: ONGOING_RPM_CARE_PLAN_REQUEST,
    payload: true
  });
  
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path = "";
  
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (role === "careprovider") {
    path = "/careprovider/";
  } else {
    path = "/patient/";
  }
  
  const custom_param = {
    action: action,
    endpoint: path + "rpm-care-plan-information" + (action.payload && action.payload.patientId ? `?patientId=${action.payload.patientId}` : ''),
    successType: GET_RPM_CARE_PLAN_INFORMATION_SUCCESS,
    errorType: GET_RPM_CARE_PLAN_INFORMATION_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
export function* fetchRPMCarePlanList(action){
  yield put({
    type: ONGOING_RPM_CARE_PLAN_LIST_REQUEST,
    payload: true
  });
  
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path = "";
  
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (role === "careprovider") {
    path = "/careprovider/";
  } else {
    path = "/patient/";
  }
  
  const custom_param = {
    action: action,
    endpoint: path + "rpm-care-plan" + (action.payload && action.payload.patientId ? `?patientId=${action.payload.patientId}` : ''),
    successType: FETCH_RPM_CARE_PLAN_LIST_SUCCESS,
    errorType: FETCH_RPM_CARE_PLAN_LIST_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}

// New saga function for RPM Care Plan Details using rpmCarePlanId
export function* deleteRpmCarePlan(action) {
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if(role === 'admin' || role === 'support'){
    path = '/admin';
  }else if(isClient){
    path = '/client';
  }else if(role == 'careprovider'){
    path = '/careprovider';
  }else{
    path = '/patient';
  }
  const custom_param = {
    action: action,
    endpoint: `${path}/rpm-care-plan-details?rpmCarePlanId=${action.payload.rpmCarePlanId}`,
    successType: "",
    errorType: ""
  };
  yield call(reusableSimpleDeleteRequest, custom_param);

  // Refresh the list so the deleted plan disappears
  yield put({
    type: "DO_FETCH_RPM_CARE_PLAN_LIST",
    payload: { patientId: action.payload.patientId }
  });
}
export function* getRPMCarePlanDetails(action){
  yield put({
    type: ONGOING_RPM_CARE_PLAN_DETAILS_REQUEST,
    payload: true
  });
  
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path = "";
  
  // Use v2 API endpoints with rpmCarePlanId
  if (role === "support" || role === "admin") {
    path = "/admin/";
  } else if (isClient) {
    path = "/client/";
  } else if (role === "careprovider") {
    path = "/careprovider/";
  } else {
    path = "/patient/";
  }
  
  const custom_param = {
    action: action,
    endpoint: path + "rpm-care-plan-details" + (action.payload && action.payload.rpmCarePlanId ? `?rpmCarePlanId=${action.payload.rpmCarePlanId}` : ''),
    successType: GET_RPM_CARE_PLAN_DETAILS_SUCCESS,
    errorType: GET_RPM_CARE_PLAN_DETAILS_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
}
function* reusableSimpleGetRequest({
  action,
  endpoint,
  successType,
  errorType
}) {
  try {
    
    yield put({
      type: "ONGOING_REQUEST",
      payload: true
    });

    let token = yield select(getToken);

    let url = endpoint;

    const response = yield axiosClient.get(url, {
      headers: {
        "x-auth-token": token
      }
    });

    if (!response) {
      throw new Error("Empty response from server");
    }

    const responseData = response.data;
    
    yield put({
      type: successType,
      payload: responseData
    });   
    yield put({
      type: "ONGOING_VERSION_REPORT_EXPORT_REQUEST",
      payload: false
    })
    if(successType == "GET_USERS_LIST_SUCCESS"){
      yield put({
        type: "ONGOING_REQUEST_ASSIGNED_USERS_LIST",
        payload: false
      });
    }
    if(successType == "GET_USER_VIOLATION_PRINT"){
      yield put({
        type: ONGOING_USER_VIOLATION_REQUEST_PRINT,
        payload: false
      });
    }
    if (successType === GET_CAREPROVIDER_ORGANIZATION) {
      yield put({
        type: ONGOING_GET_CAREPROVIDER_ORGANIZATION_REQUEST,
        payload: false
      });
    }
    if(successType == "GET_DEVICES"){
    yield put({
      type: "ONGOING_GET_DEVICE_REQUEST",
      payload: false
    });
    }
    if(successType == 'GET_USER_VIOLATIONS_RECORD_COUNT'){
      yield put({
        type: "ONGOING_USER_VIOLATION_RECORD_COUNT_REQUEST",
        payload: false
      })
    }
    if(successType == 'GET_SUPPORTS'){
      yield put({
        type: "ONGOING_GET_SUPPORT_USER_REQUEST",
        payload: false
      });
    }
    if(successType == 'EXPORT_USER_VIOLATIONS_CSV_EXPORT') {
      yield put({
        type: 'ONGOING_USER_VIOLATION_CSV_EXPORT_REQUEST',
        payload: false,
      })
    }
    if(successType == 'GET_USER_VIOLATIONS' || successType == 'GET_MY_VIOLATIONS' ){
      yield put({
        type: 'ONGOING_USER_VIOLATION_REQUEST',
        payload: false,
      })
    }
    if(successType == "GET_USERS_LIST_SUCCESS"){
      yield put({
        type: "ONGOING_REQUEST_ASSIGNED_USERS_LIST",
        payload: false
      });
    }
    if(successType == 'GET_DEFAULT_PROFILE_CONFIGRATION' || successType == 'SUBMIT_PROFILE_CONFIGRATION_NOTIFY'){
      yield put({
        type:"ONGOING_SAVE_PROFILE_REQUEST",
        payload: false,
      })
    }
    if(successType == PATIENT_REPORT_SCHEDULAR_CONFIG){
      yield put({
        type:"ONGOING_GET_PATIENT_REPORT_SCHEDULAR_CONFIG",
        payload: false,
      });
    }
    if(successType == 'GET_EXPORT_ALL_PATIENT_REPORT'){
      yield put({
        type:ONGOING_PATIENT_LIST_REQUEST_EXPORT,
        payload: false,
      })
    }
    if(successType == 'GET_ALL_STAFF_PATIENT_LIST'){
      yield put({
        type: "ONGOING_ASSIGNED_USER_REQUEST",
        payload: false
      });
    }
    if(successType == 'GET_ADDITIONAL_CAREPROVIDER_LIST'){
      yield put({
        type: "ONGOING_ASSIGNED_CAREPROVIDER_REQUEST",
        payload: false
      });
    }
    // if(successType != SAVE_FAMILY_SHARED_ACCOUNT && successType!= SAVE_PROFILE && successType != SAVE_MAINCAREPROVIDER && successType != ASSIGN_USER_SUCCESS && successType != DELETE_ALL_STAFF_PATIENTS){
    //   yield put({
    //     type: SUBMIT_OFFER_SUCCESS,
    //     payload: { isGenericSuccess: true }
    //   });
    // }
    if(successType == 'GET_BODYTRACE'){
      yield put({
        type:"ONGOING_BOTH_READING_REQUEST",
        payload: false,
      })
    }
    if(successType === 'GET_NOTIFICATION_LOGS_EXPORT_CSV_SUCCESS'){
      yield put({
        type: "ONGOING_NOTIFICATION_MESSAGES_LIST_EXPORT_REQUEST",
        payload: false
      });
    }
    if(successType === 'GET_NOTIFICATION_LOGS_SUCCESS' || successType === 'GET_VERSION_REPORTS_SUCCESS' || successType === 'GET_VERSION_REPORTS_EXPORT_SUCCESS' || successType === 'GET_ACTIVITY_LOGS_SUCCESS'){
      yield put({
        type: "ONGOING_NOTIFICATION_LOGS_REQUEST",
        payload: false
      });
      yield put({
        type: "ONGOING_VERSION_REPORT_EXPORT_REQUEST",
        payload: false
      });
    }
    if(successType == 'GET_PM_RECORD_NEW' || successType == "GET_PRINT_CCM_RECODES" || successType == "GET_EXPORT_CCM_RECODES"){
      yield put({
        type:"ONGOING_PM_SESSION_REQUEST",
        payload: false,
      })
      yield put({
        type: "ONGOING_PM_SESSION__EXPORT_REQUEST",
        payload: false
      });
      yield put({
        type: "ONGOING_PM_SESSION_PRINT_REQUEST",
        payload: false
      });
    }
    if(successType == 'GET_EXPORT_READING_RECODES'){
      yield put({
        type:"ONGOING_PDF_EXCEL_READING_REQUEST",
        payload: false,
      })
    }
    if(successType == "GET_INBOX"){
      yield put({
        type: "ONGOING_INBOX_REQUEST",
        payload: false
      });
    }
    if(successType === "GET_PATIENT_CCM_ANSWERS"){
      yield put({
        type: "ONGOING_REQUEST_FOR_CCM_QUESTION_SECTION",
        payload: false
      });
    }  
    if(successType == GET_EXPORT_ALL_ONBOARING_REPORT){
      yield put({
        type:  ONGOING_ON_BOARDING_REQUEST_EXPORT,
        payload: false
      });
    }
    if(successType === "GET_MY_QUESTIONNAIRES"){
      yield put({
        type: "ONGOING_REQUEST_QUESTIONNAIRE",
        payload: false
      });
    }
    if(successType === "GET_PATIENT_CONDITIONS"){
      yield put({
        type: "ONGOING_REQUEST_CARE_PLAN",
        payload: false
      });
    }        
    if(successType == "GET_All_ON_BORADING_DATA_SUCCESS"){
      yield put({
        type: "ONGOING_BOARDING_REQUEST",
        payload: false
      });
    }    
    if(successType == "GET_All_PATIENT_OFFERED_ACCESS_SUCCESS" || successType == "GET_EXPORT_ALL_PATIENT_REPORT"){
      yield put({
        type: "ONGOING_PATIENT_LIST_REQUEST",
        payload: false
      });
    }  
    if (successType == "GET_All_CHAT_MESSAGES_SUCCESS") {
      yield put({
        type: "ONGOING_CHAT_MESSAGE_LOAD_REQUEST",
        payload: false
      });
    }    
    if(successType == "GET_SHARED_ACCOUNT_LIST"){
      yield put({
        type: "ONGOING_SHARED_ACCOUNT_LIST_REQUEST",
        payload: false
      });
    }
    if(successType == GET_RPM_CARE_PLAN_DETAILS_SUCCESS){
      yield put({
        type: ONGOING_RPM_CARE_PLAN_DETAILS_REQUEST,
        payload: false
      });
    }
    yield put({
        type: ONGOING_RPM_CARE_PLAN_REQUEST,
        payload: false
      });
    if(successType == "GET_USER_NOTES"){
      yield put({
        type: "ONGOING_NOTE_LIST_REQUEST",
        payload: false
      });
    } 
    if(successType == 'GET_USER_VIOLATIONS'){
      yield put({
        type: "ONGOING_USER_VIOLATION_REQUEST",
        payload: false
      })
    }
    if(successType == 'GET_PROFILE' || successType === "GET_PROFILE2"){
      yield put({
        type: "ONGOING_PATIENT_PROFILE_REQUEST",
        payload: false
      });
    }
    if(successType === "SAVE_PROFILE" || successType === "SAVE_PROFILE_IMAGE"){
      yield put({
        type: "ONGOING_PATIENT_PROFILE_SAVE_REQUEST",
        payload: false
      });
    }
    if(successType == 'GET_GLOBAL_THRESHOLD_CARE_PROVIDER'){
      yield put({
        type: "ONGOING_CARE_PROVIDER_THRESHOLD_REQUEST",
        payload: false
      });
    }    
    if(successType == 'GET_PATIENT_FREQUENCY'){
      yield put({
        type: "ONGOING_TESTING_FREQUENCY_REQUEST",
        payload: false
      });
    }
    if(successType == 'GET_THIRTY_DAY_SUMMARY'){
      yield put({
        type: "ONGOING_THIRTY_DAYS_REQUEST",
        payload: false
      });
    }
    if(successType == 'GET_PATIENT_SUBMISSION_DETAILS'){
      yield put({
        type: "ONGOING_SUBMISSION_REQUEST",
        payload: false
      });
    }
    if(successType == 'GET_CAREPROVIDERS'){
      yield put({
        type: "ONGOING_CAREPROVIDER_STAFF_REQUEST",
        payload: false
      });
    }
    if(successType == 'SAVE_POPULATION' || successType == 'GET_CAREPROVIDER_EXPECTATIONS_SUCCESS' || successType == 'GET_EXPORT_PATIENT_POPULATE_REPORT'){
      yield put({
        type: "ONGOING_POPULATION_REQUEST",
        payload: false
      });
      yield put({
        type: "ONGOING_POPULATION_DATA_REQUEST",
        payload: false
      });
    }
    yield put({
      type: "ONGOING_REQUEST_DEVICE",
      payload: false
    });
    yield put({
      type: "ONGOING_REQUEST",
      payload: false
    });
  } catch (error) {
    if(successType == PATIENT_REPORT_SCHEDULAR_CONFIG){
      yield put({
        type:"ONGOING_GET_PATIENT_REPORT_SCHEDULAR_CONFIG",
        payload: false,
      });
    }
    yield put({
      type: "ONGOING_NOTIFICATION_LOGS_REQUEST",
      payload: false
    });
    if(successType === "SAVE_PROFILE" || successType === "SAVE_PROFILE_IMAGE"){
      yield put({
        type: "ONGOING_PATIENT_PROFILE_SAVE_REQUEST",
        payload: false
      });
    }
    if(successType == 'GET_EXPORT_ALL_PATIENT_REPORT'){
      yield put({
        type:ONGOING_PATIENT_LIST_REQUEST_EXPORT,
        payload: false,
      })
    }
    if(successType == 'SAVE_POPULATION' || successType == 'GET_CAREPROVIDER_EXPECTATIONS_SUCCESS' || successType == 'GET_EXPORT_PATIENT_POPULATE_REPORT'){
      yield put({
        type: "ONGOING_POPULATION_REQUEST",
        payload: false
      });
      yield put({
        type: "ONGOING_POPULATION_DATA_REQUEST",
        payload: false
      });
    }
    if (successType == "GET_All_CHAT_MESSAGES_SUCCESS") {
      yield put({
        type: "ONGOING_CHAT_MESSAGE_LOAD_REQUEST",
        payload: false
      });
    }
    if(successType === "GET_PATIENT_CONDITIONS"){
      yield put({
        type: "ONGOING_REQUEST_CARE_PLAN",
        payload: false
      });
    }
    if(successType === "GET_MY_QUESTIONNAIRES"){
      yield put({
        type: "ONGOING_REQUEST_QUESTIONNAIRE",
        payload: false
      });
    }
    if(successType == "GET_PATIENT_CCM_ANSWERS"){
      yield put({
        type: "ONGOING_REQUEST_FOR_CCM_QUESTION_SECTION",
        payload: false
      });
    }
    if(successType == GET_RPM_CARE_PLAN_DETAILS_SUCCESS){
      yield put({
        type: ONGOING_RPM_CARE_PLAN_DETAILS_REQUEST,
        payload: false
      });
    }
    if(successType == GET_RPM_CARE_PLAN_INFORMATION_SUCCESS){
      yield put({
        type: ONGOING_RPM_CARE_PLAN_REQUEST,
        payload: false
      });
    }
    if(errorType == GET_RPM_CARE_PLAN_DETAILS_FAIL){
      yield put({
        type: ONGOING_RPM_CARE_PLAN_DETAILS_REQUEST,
        payload: false
      });
    }
    if(errorType == GET_RPM_CARE_PLAN_INFORMATION_FAIL){
      yield put({
        type: ONGOING_RPM_CARE_PLAN_REQUEST,
        payload: false
      });
    }
    yield put({
      type: "ONGOING_BOARDING_REQUEST",
      payload: false
    });
    yield put({
      type: "ONGOING_REQUEST_DEVICE",
      payload: false
    });
      yield put({
        type: "ONGOING_NOTE_LIST_REQUEST",
        payload: false
      });
    yield put({
      type: "ONGOING_REQUEST",
      payload: false
    });
    yield put({
      type:"ONGOING_BOTH_READING_REQUEST",
      payload: false,
    })
    yield put({
      type:"ONGOING_CARE_PROVIDER_THRESHOLD_REQUEST",
      payload: false,
    })    
    yield put({
      type: "ONGOING_PATIENT_LIST_REQUEST",
      payload: false
    });
    yield put({
      type: "ONGOING_NOTIFICATION_LOGS_REQUEST",
      payload: false
    });
    yield put({
      type: "ONGOING_CAREPROVIDER_STAFF_REQUEST",
      payload: false
    });
    if(errorType != GET_PATIENT_SUBMISSION_DETAILS_ERROR){
      toast.error("Something Went Wrong, Cannot retrieved updated data");
    } else {
      yield put({
        type: "ONGOING_SUBMISSION_REQUEST",
        payload: false
      });
    }    
    const { response = null } = error;
    const { data = {} } = response || {};
    const { key = null, status = true } = data;
    if (response && key === "Invalid_token" && !status) {
        yield put({ type: LOGOUT_USER, payload: "" });
    } else if (error.response && errorType) {
      yield put({
        type: errorType,
        payload: error.response.data
      });
    }
  }
}

// Prefer the API's own error message so validation errors reach the user;
// fall back to the generic message when the failure carries no usable body
// (network error, timeout, HTML error page).
function buildGenericErrorPayload(error, fallback) {
  const data = error.response && error.response.data;
  return data && typeof data === "object" && data.message
    ? data
    : fallback || { message: "Something Went Wrong" };
}

function* reusableSimplePostRequestWithoutPopUp({
  action,
  endpoint,
  successType,
  errorType
}) {
  try {
    let token = yield select(getToken);
    const payloadData = action.payload;
    let url = endpoint;
    const response = yield axiosClient.post(url, payloadData, {
      headers: {
        "x-auth-token": token
      }
    });
    const responseData = response.data;
    
    yield put({
      type: successType,
      payload: responseData
    });
    // yield put({
    //   type: SUBMIT_OFFER_SUCCESS,
    //   payload: { }
    // });
    toast.success("Saved Successfully");
  } catch (error) {
    toast.error("Something Went Wrong, Cannot be saved");
    const { response = null } = error;
    const { data = {} } = response || {};
    const { key = null, status = true } = data;
    if (response && key === "Invalid_token" && !status) {
      yield put({ type: LOGOUT_USER, payload: "" });
    } else {
      if (error.response && errorType) {
        yield put({
          type: errorType,
          payload: error.response.data
        });
      }
      yield put({
        type: SUBMIT_OFFER_FAIL,
        payload: buildGenericErrorPayload(error)
      });
    }
  }
}
function* reusableFaxPostRequestWithoutPopUp({
  action,
  endpoint,
  successType,
  errorType
}) {
  try {
    let token = yield select(getToken);
    const payloadData = action.payload;
    let url = endpoint;
    const response = yield axiosClient.post(url, payloadData, {
      headers: {
        "x-auth-token": token
      }
    });
    const responseData = response.data;
    if(responseData.status){
      toast.success("The fax report request was sent successfully. Please wait a few minutes for fax report status.");
    } else {
      toast.error(responseData.message);
    }    
  } catch (error) {
    const { response = null } = error;
    const { data = {} } = response || {};
    const { key = null, status = true } = data;
    if (response && key === "Invalid_token" && !status) {
      yield put({ type: LOGOUT_USER, payload: "" });
    }
    if (error.response) {
      toast.error(error.response.message);
    } else {
      yield put({
        type: SUBMIT_OFFER_FAIL,
        payload: { message: "Send Failed!" }
      });
    }
  }
}
function* reusableSendSimplePostRequest({
  action,
  endpoint,
  successType,
  errorType
}) {
  try {
    let token = yield select(getToken);
    const payloadData = action.payload;
    let url = endpoint;
    const response = yield axiosClient.post(url, payloadData, {
      headers: {
        "x-auth-token": token
      }
    });
    const responseData = response.success;
    if(response.status == 200){      
          
      toast.success("Email was successfully sent.");
    } else{      
      toast.error(response.server_error);    
    }    
  } catch (error) {    
    const { response = null } = error;
    const { data = {} } = response || {};
    const { key = null, status = true } = data;
    if (response && key === "Invalid_token" && !status) {
      yield put({ type: LOGOUT_USER, payload: "" });
    }
    toast.error("The email could not be sent, Please try anain later.");    
  }
}
function* reusableSimplePostRequest({
  action,
  endpoint,
  successType,
  errorType,
  hideErrorToast
}) {
  try {

    let token = yield select(getToken);
    const payloadData = action.payload;
    let url = endpoint;
    let response;

    if(successType == "SUBMIT_INBOX"){
      const formData = new FormData();
      if(payloadData.admin){
        formData.append("admin",JSON.stringify(payloadData.admin));
      }
      if(payloadData.patient){
        formData.append("patient",JSON.stringify(payloadData.patient));
      }
      if(payloadData.client){
        formData.append("client",JSON.stringify(payloadData.client));
      }
      if(payloadData.staff){
        formData.append("staff",JSON.stringify(payloadData.staff));
      }
      if(payloadData.careprovider){
        formData.append("careprovider",JSON.stringify(payloadData.careprovider));
      }
      formData.append("body", payloadData.body);
      formData.append("subject", payloadData.subject);
      formData.append("files", payloadData.file);
      formData.append("messageOption",payloadData.messageOption);
      response = yield axiosClient.post(url, formData, {
        headers: {
          "x-auth-token": token,
          'Content-Type': 'multipart/form-data'
        }
      });
      //console.log('response',response);
    }else{ 
      response = yield axiosClient.post(url, payloadData, {
        headers: {
          "x-auth-token": token
        }
      });
    }
    const responseData = response.data;
    yield put({
      type: successType,
      payload: responseData
    });
    yield put({
      type: SUBMIT_OFFER_SUCCESS,
      payload: { isGenericSuccess: true }
    });
    // Set appropriate ongoing request state based on success type
    if (successType === UPDATE_RPM_CARE_PLAN_SUCCESS) {
      yield put({
        type: ONGOING_RPM_CARE_PLAN_REQUEST,
        payload: false
      });
    } else {
      yield put({
        type: "ONGOING_REQUEST",
        payload: false
      });
    }
    if(successType == SUBMIT_REPORT_SCHEDULAR_CONFIG){
      yield put({
        type:"ONGOING_GET_PATIENT_REPORT_SCHEDULAR_CONFIG",
        payload: false,
      });
    }
    if(successType != SUBMIT_INBOX && successType != "SUBMIT_QUESTIONNAIRE" && successType != SAVE_PROFILE_IMAGE && successType != SENT_APP_UPDATE_NOTIFICATION){
      if(successType != GET_CURRENT_MONTH_REPORT_SUCCESS && successType != UPDATED_INDIVIUAL_EXPECTATION){
        toast.success("Saved Successfully");
      }      
    }
    if(successType === "SAVE_PROFILE" || successType === "SAVE_PROFILE_IMAGE"){
      yield put({
        type: "ONGOING_PATIENT_PROFILE_SAVE_REQUEST",
        payload: false
      });
    }
    if(successType == SENT_APP_UPDATE_NOTIFICATION){
      toast.success("Notification send successfutly.");
    }

    if(successType == UPDATED_INDIVIUAL_EXPECTATION){
      toast.success("Expectation Update successfutly.");
    }


  } catch (error) {
    const { response = null } = error;
    const { data = {} } = response || {};
    const { key = null, status = true } = data;
    if (response && key === "Invalid_token" && !status) {
      yield put({ type: LOGOUT_USER, payload: "" });
    }
    if(successType == SUBMIT_REPORT_SCHEDULAR_CONFIG){
      yield put({
        type:"ONGOING_GET_PATIENT_REPORT_SCHEDULAR_CONFIG",
        payload: false,
      });
    }
    // Set appropriate ongoing request state based on success type
    if (successType === UPDATE_RPM_CARE_PLAN_SUCCESS) {
      yield put({
        type: ONGOING_RPM_CARE_PLAN_REQUEST,
        payload: false
      });
    }
    if(successType === "SAVE_PROFILE" || successType === "SAVE_PROFILE_IMAGE"){
      yield put({
        type: "ONGOING_PATIENT_PROFILE_SAVE_REQUEST",
        payload: false
      });
    }
    if (!hideErrorToast) {
      toast.error("Something Went Wrong, Cannot be saved");
    }
    if (error.response && errorType) {
      yield put({
        type: errorType,
        payload: error.response.data
      });
    }
    yield put({
      type: SUBMIT_OFFER_FAIL,
      payload: buildGenericErrorPayload(error)
    });
  }
}
function* reusableSimplePutRequest({
  action,
  endpoint,
  successType,
  errorType,
  deletePermission
}) {
  try {
    let token = yield select(getToken);
    let url = endpoint;
    let payload = "";
    if (action.payload) {
      payload = action.payload;
    }
    const response = yield axiosClient.put(url, action.payload, {
      headers: {
        "x-auth-token": token
      }
    });
    const responseData = response.data;
    if (responseData) {
      let role = yield select(getRole);
      let isClient = yield select(getIsClient);
      if (!role) {
        if (action.payload && role != 'patient' && !isClient) {
          yield all([call(getMyRules), call(getRuleSetByOthers), call(getMyQuestionnaireCareProvider)]);
        }
        if (deletePermission) {
          yield all([
            call(usersGivenAccessMyReading),
            call(usersOfferedAccess),
            call(assignedUsersList),
            call(usersOfferedAccessOrganization)
          ]);
        }
      }else{
        if(role != 'patient' && !isClient){
          yield all([call(getMyQuestionnaireCareProvider)]);
        }
      }
    }
    if(successType != READ_INBOX_SUCCESS && successType != READ_ALL_INBOX_SUCCESS && successType != GET_RULES_SET_BY_OTHERS_SUCCESS){
      toast.success("Updated Successfully");
    }

    yield put({
      type: successType,
      payload: responseData
    });

    if(successType == UPDATE_RPM_CARE_PLAN_SUCCESS) {
      yield put({
        type: ONGOING_RPM_CARE_PLAN_REQUEST,
        payload: false
      });
    }

    if(successType != READ_INBOX_SUCCESS){
      yield put({
        type: SUBMIT_OFFER_SUCCESS,
        payload: { isGenericSuccess: true }
      });
    }
  } catch (error) {
    toast.error("Something Went Wrong, cannot update");
    const { response = null } = error;
    const { data = {} } = response || {};
    const { key = null, status = true } = data;
    if (response && key === "Invalid_token" && !status) {
      yield put({ type: LOGOUT_USER, payload: "" });
    }
    yield put({
      type: SUBMIT_OFFER_FAIL,
      payload: buildGenericErrorPayload(error, {
        message: "Something Went Wrong. Please Try Again",
        error: "timeout"
      })
    });
  }
}
function* reusableSimpleDeleteRequest({
  action,
  endpoint,
  successType,
  errorType,
  ruleCall,
  deletePermission
}) {
  try {
    let token = yield select(getToken);
    let url = endpoint;
    const response = yield axiosClient.delete(url, {
      headers: {
        "x-auth-token": token
      }
    });
    const responseData = response.data;
    if(successType != DELETE_INBOX_SUCCESS && successType != DELETE_ALL_INBOX_SUCCESS){
      toast.success("Deleted Successfully");
    }

    if(successType == DELETE_ALL_INBOX_SUCCESS || successType == DELETE_INBOX_SUCCESS){
      yield put({
        type: SUBMIT_OFFER_SUCCESS,
        payload: { isGenericSuccess: true }
      });
    }
    // yield put({
    //   type: successType,
    //   payload: responseData
    // });
    if (ruleCall) {
      yield all([call(getMyRules), call(getRuleSetByOthers), call(getMyQuestionnaireCareProvider)]);
    }
    if (deletePermission) {
      yield all([
        call(usersGivenAccessMyReading),
        call(usersOfferedAccess),
        call(assignedUsersList),
        call(usersOfferedAccessOrganization)        
      ]);
    }

    // yield put({
    //   type: SUBMIT_OFFER_SUCCESS,
    //   payload: { isGenericSuccess: true }
    // });
  } catch (error) {
    const { response = null } = error;
    if (response) {
      const { data = {} } = response;
      const { key = null, status = true } = data;
      if (response && key === "Invalid_token" && !status) {
        yield put({ type: LOGOUT_USER, payload: "" });
      }
      const { error = "" } = data;
      //toast.error("Cannot Delete Error Code:" + error);
      toast.error(data.message);
    }
    // toast.error("Something Went Wrong, cannot delete");
    // if (error.response) {
    //   yield put({
    //     type: errorType,
    //     payload: error.response.data
    //   });
    //   yield put({
    //     type: SUBMIT_OFFER_FAIL,
    //     payload: error.response.data
    //   });
    // }
    // yield put({
    //   type: SUBMIT_OFFER_FAIL,
    //   payload: { data: { message: "Something Went Wrong", error: "failed" } }
    // });
  }
}

export function* cptCodeDashboard(action) {
  yield put({
    type: ONGOING_CPT_CODE_DASHBOARD_REQUEST,
    payload: true
  });
  
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if (role === 'admin' || role === 'support') {
    path = '/admin';
  } else if (isClient) {
    path = '/client';
  } else if (role == 'careprovider') {
    path = '/careprovider';
  } else {
    path = '/patient';
  }
  
  let endpoint = path + "/cpt-code/dashboard";
  const queryParams = action.payload ? `${jsonToQueryString(action.payload)}` : "";
  
  const custom_param = {
    endpoint: endpoint + queryParams,
    successType: GET_CPT_CODE_DASHBOARD_SUCCESS,
    errorType: GET_CPT_CODE_DASHBOARD_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);
  
  yield put({
    type: ONGOING_CPT_CODE_DASHBOARD_REQUEST,
    payload: false
  });
}

export function* cptCodePatientList(action) {
  yield put({
    type: ONGOING_CPT_CODE_PATIENT_LIST_REQUEST,
    payload: true
  });
  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if (role === 'admin' || role === 'support') {
    path = '/admin';
  } else if (isClient) {
    path = '/client';
  } else if (role == 'careprovider') {
    path = '/careprovider';
  } else {
    path = '/patient';
  }
  const endpoint = `${path}/cpt-performance/popup-patients`;
  const queryParams = action.payload ? `${jsonToQueryString(action.payload)}` : "";
  if (process.env.NODE_ENV !== "production") {
    // Debug helper to verify popup API payload integration.
    // eslint-disable-next-line no-console
    console.log("[CPT Popup][Saga] Request payload:", action.payload || {});
    // eslint-disable-next-line no-console
    console.log("[CPT Popup][Saga] Request URL:", endpoint + queryParams);
  }
  const custom_param = {
    endpoint: endpoint + queryParams,
    successType: GET_CPT_CODE_PATIENT_LIST_SUCCESS,
    errorType: GET_CPT_CODE_PATIENT_LIST_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);

  yield put({
    type: ONGOING_CPT_CODE_PATIENT_LIST_REQUEST,
    payload: false
  });
}

export function* componentPatients(action) {
  yield put({
    type: ONGOING_COMPONENT_PATIENTS_REQUEST,
    payload: true
  });

  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if (role === 'admin' || role === 'support') {
    path = '/admin';
  } else if (isClient) {
    path = '/client';
  } else if (role == 'careprovider') {
    path = '/careprovider';
  } else {
    path = '/patient';
  }

  let endpoint = path + "/cpt-code/component-patients";
  const queryParams = action.payload ? `${jsonToQueryString(action.payload)}` : "";

  const custom_param = {
    endpoint: endpoint + queryParams,
    successType: GET_COMPONENT_PATIENTS_SUCCESS,
    errorType: GET_COMPONENT_PATIENTS_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);

  yield put({
    type: ONGOING_COMPONENT_PATIENTS_REQUEST,
    payload: false
  });
}

export function* monthlyPerformanceReport(action) {
  yield put({
    type: ONGOING_MONTHLY_PERFORMANCE_REPORT_REQUEST,
    payload: true
  });

  let role = yield select(getRole);
  let isClient = yield select(getIsClient);
  let path;
  if (role === "admin" || role === "support") {
    path = "/admin";
  } else if (isClient || role == "careprovider") {
    path = "/careprovider";
  } else {
    path = "/careprovider";
  }

  let endpoint = path + "/cpt-code/monthly-performance-report";
  const queryParams = action.payload ? `${jsonToQueryString(action.payload)}` : "";

  const custom_param = {
    endpoint: endpoint + queryParams,
    successType: GET_MONTHLY_PERFORMANCE_REPORT_SUCCESS,
    errorType: GET_MONTHLY_PERFORMANCE_REPORT_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);

  yield put({
    type: ONGOING_MONTHLY_PERFORMANCE_REPORT_REQUEST,
    payload: false
  });
}

export function* monthlyPhoneConsultationDashboard(action) {
  yield put({
    type: ONGOING_MONTHLY_PHONE_CONSULTATION_DASHBOARD_REQUEST,
    payload: true
  });

  const role = yield select(getRole);
  const isClient = yield select(getIsClient);
  let path;
  if (role === "admin" || role === "support") {
    path = "/admin";
  } else if (isClient || role === "careprovider") {
    path = "/careprovider";
  } else {
    path = "/careprovider";
  }

  const endpoint = `${path}/cpt-code/monthly-phone-consultation-dashboard`;
  const queryParams = action.payload ? `${jsonToQueryString(action.payload)}` : "";

  const custom_param = {
    endpoint: endpoint + queryParams,
    successType: GET_MONTHLY_PHONE_CONSULTATION_DASHBOARD_SUCCESS,
    errorType: GET_MONTHLY_PHONE_CONSULTATION_DASHBOARD_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);

  yield put({
    type: ONGOING_MONTHLY_PHONE_CONSULTATION_DASHBOARD_REQUEST,
    payload: false
  });
}

export function* monthlyPhoneTeamMemberDetail(action) {
  yield put({
    type: ONGOING_MONTHLY_PHONE_TEAM_MEMBER_DETAIL_REQUEST,
    payload: true
  });

  const role = yield select(getRole);
  const isClient = yield select(getIsClient);
  let path;
  if (role === "admin" || role === "support") {
    path = "/admin";
  } else if (isClient || role === "careprovider") {
    path = "/careprovider";
  } else {
    path = "/careprovider";
  }

  const endpoint = `${path}/cpt-code/monthly-phone-consultation-team-member-detail`;
  const queryParams = action.payload ? `${jsonToQueryString(action.payload)}` : "";

  const custom_param = {
    endpoint: endpoint + queryParams,
    successType: GET_MONTHLY_PHONE_TEAM_MEMBER_DETAIL_SUCCESS,
    errorType: GET_MONTHLY_PHONE_TEAM_MEMBER_DETAIL_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);

  yield put({
    type: ONGOING_MONTHLY_PHONE_TEAM_MEMBER_DETAIL_REQUEST,
    payload: false
  });
}

export function* nonAdherentBackToBackReport(action) {
  yield put({
    type: ONGOING_NON_ADHERENT_BACK_TO_BACK_REPORT_REQUEST,
    payload: true
  });

  let role = yield select(getRole);
  let path;
  if (role === "admin" || role === "support") {
    path = "/admin";
  } else {
    path = "/careprovider";
  }

  const queryParams = action.payload ? `${jsonToQueryString(action.payload)}` : "";
  const custom_param = {
    endpoint: `${path}/cpt-code/non-adherent-back-to-back${queryParams}`,
    successType: GET_NON_ADHERENT_BACK_TO_BACK_REPORT_SUCCESS,
    errorType: GET_NON_ADHERENT_BACK_TO_BACK_REPORT_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);

  yield put({
    type: ONGOING_NON_ADHERENT_BACK_TO_BACK_REPORT_REQUEST,
    payload: false
  });
}

export function* carePlanReviewAndUpdateReport(action) {
  yield put({
    type: ONGOING_CARE_PLAN_REVIEW_REPORT_REQUEST,
    payload: true
  });

  let role = yield select(getRole);
  let path;
  if (role === "admin" || role === "support") {
    path = "/admin";
  } else {
    path = "/careprovider";
  }

  const queryParams = action.payload ? `${jsonToQueryString(action.payload)}` : "";
  const custom_param = {
    endpoint: `${path}/care-plan/review-and-update-report${queryParams}`,
    successType: GET_CARE_PLAN_REVIEW_REPORT_SUCCESS,
    errorType: GET_CARE_PLAN_REVIEW_REPORT_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);

  yield put({
    type: ONGOING_CARE_PLAN_REVIEW_REPORT_REQUEST,
    payload: false
  });
}

export function* nonAdherentBackToBackTimeline(action) {
  yield put({
    type: ONGOING_NON_ADHERENT_BACK_TO_BACK_TIMELINE_REQUEST,
    payload: true
  });

  let role = yield select(getRole);
  let path;
  if (role === "admin" || role === "support") {
    path = "/admin";
  } else {
    path = "/careprovider";
  }

  const queryParams = action.payload ? `${jsonToQueryString(action.payload)}` : "";
  const custom_param = {
    endpoint: `${path}/cpt-code/non-adherent-back-to-back-patient-timeline${queryParams}`,
    successType: GET_NON_ADHERENT_BACK_TO_BACK_TIMELINE_SUCCESS,
    errorType: GET_NON_ADHERENT_BACK_TO_BACK_TIMELINE_FAIL
  };
  yield call(reusableSimpleGetRequest, custom_param);

  yield put({
    type: ONGOING_NON_ADHERENT_BACK_TO_BACK_TIMELINE_REQUEST,
    payload: false
  });
}
// Escalation Plan Sagas 
export function* getEscalationPlans(action) {
  try {
    yield put({ type: ONGOING_ESCALATION_PLAN_REQUEST, payload: true });
    const token = yield select(getToken);
    const response = yield axiosClient.get(`/careprovider/escalation-plan`, {
      headers: { "x-auth-token": token }
    });
    yield put({ type: GET_ESCALATION_PLANS, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to load escalation plan");
  } finally {
    yield put({ type: ONGOING_ESCALATION_PLAN_REQUEST, payload: false });
  }
}

export function* saveEscalationPlan(action) {
  try {
    yield put({ type: ONGOING_ESCALATION_PLAN_REQUEST, payload: true });
    const token = yield select(getToken);
    const response = yield axiosClient.post(`/careprovider/escalation-plan`, action.payload, {
      headers: { "x-auth-token": token }
    });
    toast.success("Escalation plan saved successfully");
    yield put({ type: GET_ESCALATION_PLANS, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to save escalation plan");
  } finally {
    yield put({ type: ONGOING_ESCALATION_PLAN_REQUEST, payload: false });
  }
}

export function* updateEscalationPlan(action) {
  try {
    yield put({ type: ONGOING_ESCALATION_PLAN_REQUEST, payload: true });
    const token = yield select(getToken);
    const { id, ...data } = action.payload;
    const response = yield axiosClient.put(`/careprovider/escalation-plan/${encryptRequest(id)}`, data, {
      headers: { "x-auth-token": token }
    });
    toast.success("Escalation plan updated successfully");
    yield put({ type: GET_ESCALATION_PLANS, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to update escalation plan");
  } finally {
    yield put({ type: ONGOING_ESCALATION_PLAN_REQUEST, payload: false });
  }
}

// Goals of Care Sagas 
export function* getGoalsOfCare(action) {
  try {
    yield put({ type: ONGOING_GOALS_OF_CARE_REQUEST, payload: true });
    const token = yield select(getToken);
    const response = yield axiosClient.get(`/careprovider/goals-of-care`, {
      headers: { "x-auth-token": token }
    });
    yield put({ type: GET_GOALS_OF_CARE, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to load goals of care");
  } finally {
    yield put({ type: ONGOING_GOALS_OF_CARE_REQUEST, payload: false });
  }
}

export function* saveGoalsOfCare(action) {
  try {
    yield put({ type: ONGOING_GOALS_OF_CARE_REQUEST, payload: true });
    const token = yield select(getToken);
    const response = yield axiosClient.post(`/careprovider/goals-of-care`, action.payload, {
      headers: { "x-auth-token": token }
    });
    toast.success("Goals of care saved successfully");
    yield put({ type: GET_GOALS_OF_CARE, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to save goals of care");
  } finally {
    yield put({ type: ONGOING_GOALS_OF_CARE_REQUEST, payload: false });
  }
}

export function* updateGoalsOfCare(action) {
  try {
    yield put({ type: ONGOING_GOALS_OF_CARE_REQUEST, payload: true });
    const token = yield select(getToken);
    const { id, ...data } = action.payload;
    const response = yield axiosClient.put(`/careprovider/goals-of-care/${encryptRequest(id)}`, data, {
      headers: { "x-auth-token": token }
    });
    toast.success("Goals of care updated successfully");
    yield put({ type: GET_GOALS_OF_CARE, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to update goals of care");
  } finally {
    yield put({ type: ONGOING_GOALS_OF_CARE_REQUEST, payload: false });
  }
}

// Admin Escalation Plan Sagas 
export function* getEscalationPlansAdmin(action) {
  try {
    yield put({ type: ONGOING_ESCALATION_PLAN_ADMIN_REQUEST, payload: true });
    const token = yield select(getToken);
    const { careProviderId } = action.payload;
    const response = yield axiosClient.get(`/admin/escalation-plan?careProviderId=${careProviderId}`, {
      headers: { "x-auth-token": token }
    });
    yield put({ type: GET_ESCALATION_PLANS_ADMIN, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to load escalation plan");
  } finally {
    yield put({ type: ONGOING_ESCALATION_PLAN_ADMIN_REQUEST, payload: false });
  }
}

export function* saveEscalationPlanAdmin(action) {
  try {
    yield put({ type: ONGOING_ESCALATION_PLAN_ADMIN_REQUEST, payload: true });
    const token = yield select(getToken);
    const response = yield axiosClient.post(`/admin/escalation-plan`, action.payload, {
      headers: { "x-auth-token": token }
    });
    toast.success("Escalation plan saved successfully");
    yield put({ type: GET_ESCALATION_PLANS_ADMIN, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to save escalation plan");
  } finally {
    yield put({ type: ONGOING_ESCALATION_PLAN_ADMIN_REQUEST, payload: false });
  }
}

export function* updateEscalationPlanAdmin(action) {
  try {
    yield put({ type: ONGOING_ESCALATION_PLAN_ADMIN_REQUEST, payload: true });
    const token = yield select(getToken);
    const { id, ...data } = action.payload;
    const response = yield axiosClient.put(`/admin/escalation-plan/${encryptRequest(id)}`, data, {
      headers: { "x-auth-token": token }
    });
    toast.success("Escalation plan updated successfully");
    yield put({ type: GET_ESCALATION_PLANS_ADMIN, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to update escalation plan");
  } finally {
    yield put({ type: ONGOING_ESCALATION_PLAN_ADMIN_REQUEST, payload: false });
  }
}

//Admin Goals of Care Sagas 
export function* getGoalsOfCareAdmin(action) {
  try {
    yield put({ type: ONGOING_GOALS_OF_CARE_ADMIN_REQUEST, payload: true });
    const token = yield select(getToken);
    const { careProviderId } = action.payload;
    const response = yield axiosClient.get(`/admin/goals-of-care?careProviderId=${careProviderId}`, {
      headers: { "x-auth-token": token }
    });
    yield put({ type: GET_GOALS_OF_CARE_ADMIN, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to load goals of care");
  } finally {
    yield put({ type: ONGOING_GOALS_OF_CARE_ADMIN_REQUEST, payload: false });
  }
}

export function* saveGoalsOfCareAdmin(action) {
  try {
    yield put({ type: ONGOING_GOALS_OF_CARE_ADMIN_REQUEST, payload: true });
    const token = yield select(getToken);
    const response = yield axiosClient.post(`/admin/goals-of-care`, action.payload, {
      headers: { "x-auth-token": token }
    });
    toast.success("Goals of care saved successfully");
    yield put({ type: GET_GOALS_OF_CARE_ADMIN, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to save goals of care");
  } finally {
    yield put({ type: ONGOING_GOALS_OF_CARE_ADMIN_REQUEST, payload: false });
  }
}

export function* updateGoalsOfCareAdmin(action) {
  try {
    yield put({ type: ONGOING_GOALS_OF_CARE_ADMIN_REQUEST, payload: true });
    const token = yield select(getToken);
    const { id, ...data } = action.payload;
    const response = yield axiosClient.put(`/admin/goals-of-care/${encryptRequest(id)}`, data, {
      headers: { "x-auth-token": token }
    });
    toast.success("Goals of care updated successfully");
    yield put({ type: GET_GOALS_OF_CARE_ADMIN, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to update goals of care");
  } finally {
    yield put({ type: ONGOING_GOALS_OF_CARE_ADMIN_REQUEST, payload: false });
  }
}

// Staff Escalation Plan Sagas for (careprovider viewing staff member)
export function* getEscalationPlansStaff(action) {
  try {
    yield put({ type: ONGOING_ESCALATION_PLAN_STAFF_REQUEST, payload: true });
    const token = yield select(getToken);
    const { staffId } = action.payload;
    const response = yield axiosClient.get(`/careprovider/escalation-plan?staffId=${staffId}`, {
      headers: { "x-auth-token": token }
    });
    yield put({ type: GET_ESCALATION_PLANS_STAFF, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to load escalation plan");
  } finally {
    yield put({ type: ONGOING_ESCALATION_PLAN_STAFF_REQUEST, payload: false });
  }
}

export function* saveEscalationPlanStaff(action) {
  try {
    yield put({ type: ONGOING_ESCALATION_PLAN_STAFF_REQUEST, payload: true });
    const token = yield select(getToken);
    const response = yield axiosClient.post(`/careprovider/escalation-plan`, action.payload, {
      headers: { "x-auth-token": token }
    });
    toast.success("Escalation plan saved successfully");
    yield put({ type: GET_ESCALATION_PLANS_STAFF, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to save escalation plan");
  } finally {
    yield put({ type: ONGOING_ESCALATION_PLAN_STAFF_REQUEST, payload: false });
  }
}

// Staff Goals of Care Sagas for (careprovider viewing staff member)
export function* getGoalsOfCareStaff(action) {
  try {
    yield put({ type: ONGOING_GOALS_OF_CARE_STAFF_REQUEST, payload: true });
    const token = yield select(getToken);
    const { staffId } = action.payload;
    const response = yield axiosClient.get(`/careprovider/goals-of-care?staffId=${staffId}`, {
      headers: { "x-auth-token": token }
    });
    yield put({ type: GET_GOALS_OF_CARE_STAFF, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to load goals of care");
  } finally {
    yield put({ type: ONGOING_GOALS_OF_CARE_STAFF_REQUEST, payload: false });
  }
}

export function* saveGoalsOfCareStaff(action) {
  try {
    yield put({ type: ONGOING_GOALS_OF_CARE_STAFF_REQUEST, payload: true });
    const token = yield select(getToken);
    const response = yield axiosClient.post(`/careprovider/goals-of-care`, action.payload, {
      headers: { "x-auth-token": token }
    });
    toast.success("Goals of care saved successfully");
    yield put({ type: GET_GOALS_OF_CARE_STAFF, payload: response.data.data });
  } catch (error) {
    toast.error("Failed to save goals of care");
  } finally {
    yield put({ type: ONGOING_GOALS_OF_CARE_STAFF_REQUEST, payload: false });
  }
}
